// 260707 온라인 현판 상수 — BE QrTemplate.java의 category/platform 키와 1:1 계약 (rules/17-qr-landing-domain.md)
// 새 업종/타일 추가 시 BE QrTemplate와 여기를 같이 갱신할 것 (키 불일치 = 라벨 없는 타일).
// 260724 카테고리 재정비: category 저장값 = 소분류 키(QR_CATEGORY_LIST 137종, BE GROUP_OF와 1:1).
//   category로 맵/분기를 태우기 전 반드시 qrTplOf()로 템플릿그룹 리졸브(레거시 23키는 identity).
// guide = 관리 모드에서 "이 링크 어디서 복사하나" 안내 (LINK형 전용, 260708 대표 지시).

// QR BE(ServiceException)는 500 + text/plain 본문에 메시지를 담는다(JSON {message} 아님) →
//   axios responseType:json이 파싱 실패로 data를 문자열로 남김. data?.message는 undefined라 폴백만 떴었음.
//   문자열이면 그대로 메시지로 사용(잠금 '5회 초과' 등 BE 메시지 노출).
export const qrErrMsg = (data, fallback) =>
  (typeof data === 'string' && data.trim()) ? data.trim() : (data?.message || fallback);

// 260709 타일 유형(kind) — 관리 편집기·소비자 표시기가 이 값으로 분기(대표 카테고리 전수 리뷰 반영).
//   LINK: 외부 url / HOURS: 요일별 시간표 / MENU: 품목(이름·가격·설명·사진) / TABLE: 항목·값 2열
//   STAFF: 인물카드(이름·직함·사진·소개) / GALLERY: 사진 여러 장 / BEFORE_AFTER: 전후 사진쌍
//   RICHTEXT: 소개글+사진 / EVENT: 제목·기간·내용·사진 / MSG: 방문자 메시지→비즈톡or접수함
//   FUNC: 특수(전화·비즈톡·간판온·와이파이·명함) / TEXT: 단문 / REMOVE: 폐지 예정
export const QR_TILE_KIND = {
  // 링크형
  MAP: 'LINK', INSTAGRAM: 'LINK', NAVER_PLACE: 'LINK', GOOGLE_MAP: 'LINK', HOMEPAGE: 'LINK', KAKAO_CH: 'LINK',
  YOUTUBE: 'LINK', FACEBOOK: 'LINK', BLOG: 'LINK', SHOP: 'LINK',
  NAVER_ORDER: 'LINK', KAKAO_ORDER: 'LINK', BAEMIN: 'LINK', YOGIYO: 'LINK', COUPANG_EATS: 'LINK', DELIVERY: 'LINK',
  NAVER_BOOKING: 'LINK', RESERVATION: 'LINK', CATALOG: 'LINK',
  SERMON_TUBE: 'LINK',
  // 260729 오늘의 말씀 — 웰다잉 성구 원장에서 하루 한 구절을 받아 보여준다.
  //   사장이 채울 내용이 없는 라이브 타일이라 WAITING·ATTEND처럼 콘텐츠 무관 항상 활성.
  DAILY_VERSE: 'VERSE',
  // 요일별 시간
  HOURS: 'HOURS', CLINIC_HOURS: 'HOURS',
  // 메뉴(품목·가격·사진)
  MENU: 'MENU', PRICE_MENU: 'MENU',
  // 2열 표 (항목/값·이름/시간)
  ORIGIN_LABEL: 'TABLE', NON_COVERED: 'TABLE', DEPARTMENTS: 'TABLE',
  // 260729 시트9 버그#9 — 수강료가 '일반 메뉴판처럼' 2열이라 요일·시간별 금액을 못 적었다(부장님).
  //   TABLE(항목/값)에서 떼어내 반이름 + 요일·시간(선택) + 금액 구조로. 헬스 이용권처럼
  //   요일·시간이 없는 상품은 비워두면 되고, 레거시 {k,v} 행은 parseJson이 흡수한다.
  TUITION: 'TUITION',
  SERVICE_TIME: 'TABLE', // 교회 예배 시간(예배명/시간)
  MEETING_TIME: 'TABLE', // 단체 모임 일정(모임명/시간)
  OFFERING: 'TABLE',     // 260716 교회 헌금 안내(헌금종류/계좌) — 대표 오후회의(155743)
  TRANSFER: 'TABLE',     // 260730 계좌이체(입금계좌) — OFFERING과 동일 포맷(항목/계좌 2열 + 계좌 복사). 교회 아닌 업종용
  CHECKIN: 'TABLE',      // 260724 숙박 입실·퇴실 안내(체크인/시간) — 카테고리 재정비 LODGING
  ADMISSION: 'TABLE',    // 260724 입장료(구분/요금) — CULTURE·PLAY
  // 인물 소개(이름·직함·사진·소개)
  STAFF_INTRO: 'STAFF', PASTOR_INTRO: 'STAFF',
  CONTACTS: 'STAFF',     // 260721 담당자 안내 — 인물카드 편집기·tel: 렌더 재사용(사무 담당자=이름/직함/직통)
  SMALL_GROUP: 'STAFF',  // 260716 교회 소모임·구역(담당자 카드+전화) — 대표 오후회의(155743)
  // 사진 갤러리
  GALLERY: 'GALLERY', WORK_SITE: 'GALLERY',
  BEFORE_AFTER: 'BEFORE_AFTER',
  // 사진 여러 장 + PDF 파일 (260720 대표: 포폴·주보 직접 업로드 — URL 대신 사진·PDF)
  PORTFOLIO: 'MEDIA', BULLETIN: 'MEDIA',
  // 부동산 직접 매물 카드 (260720 대표: 링크 대신 사진·가격·면적·설명 직접 입력)
  LISTINGS: 'LISTINGS',
  // 260724 숙박 객실 카드(이름·기준/최대 인원·요금·사진·설명 멀티) — 카테고리 재정비 신규 kind. text/photos 직접입력 병행(SHUTTLE 관례)
  ROOMS: 'ROOMS',
  // 260721 #8 실시간 대기열(웨이팅) — 고객이 QR로 번호표 뽑고 순서 폴링, 사장이 호출. 전용 시트·관리 라이브패널
  WAITING: 'WAITING',
  // 260723 출퇴근(근태) — 직원 이름+PIN→기기 기억, 위치게이트 punch. 전용 시트(WAITING 선례)
  ATTENDANCE: 'ATTEND',
  // 소개글+사진 (260709 세분화: PASTOR_INTRO·SERVICE_TIME 중복 선언 제거 — 뒤 선언이 이겨 STAFF·TABLE 편집기가 죽어 있었음)
  COMPANY_INTRO: 'RICHTEXT', SERVICE_INTRO: 'RICHTEXT', HOW_TO_USE: 'RICHTEXT',
  DIRECTIONS: 'RICHTEXT', FLOOR_PARKING: 'RICHTEXT', PARKING: 'RICHTEXT',
  CHURCH_INTRO: 'RICHTEXT', NEWCOMER: 'RICHTEXT', EMERGENCY: 'RICHTEXT',
  // 260804 긴급 공지 — 본문+사진은 RICHTEXT 편집기·렌더러 그대로. 노출 종료일(endMode/endDate)만 얹는다.
  URGENT_NOTICE: 'RICHTEXT',
  LICENSE_PROOF: 'RICHTEXT', COMPANY_NEWS: 'RICHTEXT', RESULTS: 'RICHTEXT',
  REFUND_GUIDE: 'RICHTEXT', COURIER_NOTE: 'RICHTEXT',
  AMENITY: 'RICHTEXT',   // 260724 숙박 부대시설·비품 — LODGING
  PICKUP: 'RICHTEXT',    // 260724 픽업·대차 안내 — CAR(카센터·타이어·세차·렌터카)
  // 260721 카테고리 템플릿 v1 — 시간표 구조화(수업명+요일+시간 select). 교육/운동 4업종 공유, 레거시 text/photos는 폴백
  TIMETABLE: 'TIMETABLE',
  // 260721 셔틀버스 구조화(호차 카드: 노선·등원/하원 시간·태우는 반) — 학원·도장 차량 운행. 레거시 text/photos 폴백(구 RICHTEXT 저장분)
  SHUTTLE: 'SHUTTLE',
  // 260825 학원 확장 — 커리큘럼(반 소개) 구조화: 부(학년 그룹) 섹션 + 반 카드(이름·대상·소개·사진). 직접입력 text/photos 병행(SHUTTLE 관례)
  CURRICULUM: 'CLASSES',
  // 260721 화장실 안내(위치·비번·메모) — 와이파이 3번째 칸에서 분리(WiFi=WiFi, 화장실=화장실). 대표 지적
  TOILET: 'TOILET',
  // 이벤트
  FIRST_EVENT: 'EVENT', TRIAL: 'EVENT', EVENT_INFO: 'EVENT',
  // 260721 교회 행사 멀티 — 여러 행사 카드(부활절·수련회…). 단일 EVENT와 분리, 큐브 버튼→목록 페이지. 레거시 단일 {title,…} dual-read
  CHURCH_EVENT: 'EVENTS',
  SHOWTIME: 'EVENTS',    // 260724 공연·상영 일정 멀티카드 — CULTURE(공연장·전시관·영화관·체험레저), CHURCH_EVENT 편집기·렌더러 재사용
  ACADEMY_EVENT: 'EVENTS', // 260825 학원 일정(개강·설명회·방학) — CHURCH_EVENT 편집기·렌더러 공용
  // QR 구인 — 공고 구조화 콘텐츠 + 비로그인 간편 지원 접수
  RECRUIT: 'RECRUIT',
  // 260814 매장 Q&A — 방문자 자유챗봇 대체(대표 결정). 사장이 문답을 등록(AI 초안 지원),
  //   손님은 랜딩 아코디언 시트로 본다. contentJson={items:[{q,a}]} — BE 강제 캡: items≤10·q≤80자·a≤500자.
  FAQ: 'FAQ',
  // 260721 회의: 오더판 대기 게임(룰렛·사다리) — 경품은 사장 설정, 당첨=후기 작성 확인 후 직원 지급
  GAME: 'GAME',
  // 접수/메시지 → 비즈톡 or 접수함
  DOORBELL: 'MSG', BUSY_MESSAGE: 'MSG', QUOTE: 'MSG', CONSULT: 'MSG', GROUP_INQUIRY: 'MSG',
  CAR_REG: 'MSG', REPORT_ISSUE: 'MSG', FRANCHISE: 'MSG', JOIN_US: 'MSG',
  LEVEL_TEST: 'MSG',     // 260825 학원 확장 — 접수형(BE INBOX_TYPE_LABEL·BIZTALK_REQUIRED 짝)
  // 특수 기능 (기존 유지)
  PHONE: 'FUNC', BIZTALK: 'FUNC', GANPANON: 'FUNC', WIFI: 'FUNC', VCARD: 'VCARD', NOTICE: 'TEXT',
  SAVE_BIZ: 'FUNC',
  SAINT_BIZ: 'FUNC' // 260722 시트5 #31 대표컨펌 — 성도 사업장 타일화(상시 섹션→큐브·시트)
};

// 260709 폐지 예정(대표 리뷰): 오늘의메뉴할인=한줄공지와 중복 / 테이블주문=주문링크와 중복
// 260805 정리(14) 공통#3 — DIRECTIONS('찾아오시는 길') 편입. 부장 "오시는길과 찾아오시는길 중복인데,
//   1개 항목으로 하고 공유하는 게 좋아 보임" → MAP('오시는 길') 하나로 합치고, 누르면 [지도 열기 / 주소 공유]를 고른다.
//   ⚠️BE(QrTemplate)는 아직 7개 템플릿에 DIRECTIONS를 시딩한다 — 서버 카탈로그를 안 건드리고 화면에서만 합친 것이라
//   기개통 자산의 행은 그대로 남는다. 거기 적어둔 주소는 QrLanding.mapOrDirectionsAddr가 폴백으로 계속 읽는다.
export const QR_TILE_REMOVED = ['TODAY_SPECIAL', 'TABLE_ORDER', 'DIRECTIONS'];

// 260716 준비 중(대표 "어중간하게 열지마" — MSG 전수감사) — 폼·전달경로가 아직 없어 켜도 먹통인 문의 타일.
//   REMOVED(영구폐지)와 달리 임시 숨김 — 실제 구현되면 이 리스트에서 빼면 부활. 렌더(isReady)·골라담기·관리목록 3곳서 제외.
//   REPORT_ISSUE·FRANCHISE=폼·리드적재 없음(BE도 거부) / BUSY_MESSAGE=시술중 메시지 입력창 없음.
//   260721 #8: WAITING(웨이팅)=실시간 대기열 구현 완료 → 해제(전용 엔드포인트 /api/qr/waiting/*).
//   260722 시트7 V14: DOORBELL(벨 누르기)=원탭 방문 알림 구현 완료 → 해제(POST /api/qr/doorbell/notify, 앱 연동 사장 딩동 푸시+SMS 폴백[클럽]).
//   260727 대표 녹취: JOIN_US(가입·참여 문의)=단체 전용이라 일반 매장에 혼선 → 준비중(폼·리드적재 미구현). "애매모호한 건 준비적으로 가라".
//   260730 유저 판단: KAKAO_ORDER — '카카오 주문하기'(음식)와 '톡딜'(공동구매 상품 판매)이 다른 제품인데
//     라벨·안내 문구가 서로 다른 걸 가리키고 있었고, 대표도 "이게 뭐냐"에 답이 막혔다(=사장도 모른다).
//     운영 실측으로 링크형 토핑 URL 채운 행이 0건이라 내려도 잃는 게 없다. 카카오 실제 화면에서
//     경로를 확인한 뒤 이름·guide를 확정하고 이 목록에서 빼면 부활한다.
export const QR_TILE_COMING_SOON = ['REPORT_ISSUE', 'FRANCHISE', 'BUSY_MESSAGE', 'JOIN_US', 'KAKAO_ORDER'];

// 260805 유저 지시 — 문의형은 **간판ON 업체 연동(businessNo)이 있어야** 켜고 쓸 수 있다.
//   손님 문의를 비즈톡으로 전달하는 게 본체라 연동이 없으면 갈 곳이 없다. 미연동이면:
//     · 손님 화면에 안 뜨고 · 사장이 켜려 하면 연결 안내창 → connect-auto로 유도
//   ⚠️BE QrTemplate.BIZTALK_REQUIRED와 **같은 목록이어야 한다** — 한쪽만 고치면
//     버튼은 켜지는데 서버가 접수를 거부하는 유령 상태가 된다(진원 2곳 분산의 대가).
//   ⚠️DOORBELL은 여기 없다 — 그건 businessNo가 아니라 userNo(앱 계정) 게이트로 축이 다르다.
export const QR_BIZTALK_REQUIRED = [
  'BIZTALK', 'CONSULT', 'QUOTE', 'GROUP_INQUIRY', 'JOIN_US',
  'BUSY_MESSAGE', 'REPORT_ISSUE', 'FRANCHISE',
  'CAR_REG', 'RECRUIT', 'LEVEL_TEST' // 260825 학원 확장
];
export const qrNeedsBiztalk = platform => QR_BIZTALK_REQUIRED.includes(platform);

// 260910 대표·유저 — 문의형 타일의 '받는 방법'을 사장이 고른다: 비즈톡(기본) / 카카오톡 채널 채팅. 전 업종, 간판ON 미연동 현판도 카카오는 가능.
//   대상은 실제로 비즈톡으로 가는 5개뿐(CAR_REG·RECRUIT는 자체 접수폼, JOIN_US 등 4개는 준비 중).
//   저장처 = 타일 행 contentJson {"channel":"kakao","kakaoUrl":"https://pf.kakao.com/_xxx/chat"} — url 컬럼은 관리 일반 저장이 url:''로 지워서 못 쓴다.
//   ⚠️BE QrTemplate.KAKAO_CHANNEL_PLATFORMS·validateInquiryChannelJson과 같은 계약(호스트 pf.kakao.com|open.kakao.com·https).
export const QR_KAKAO_CHANNEL_PLATFORMS = ['BIZTALK', 'CONSULT', 'QUOTE', 'GROUP_INQUIRY', 'LEVEL_TEST'];
export const qrKakaoChannelOf = tile => {
  if (!tile || !QR_KAKAO_CHANNEL_PLATFORMS.includes(tile.platform) || !tile.contentJson) return '';
  let j = null;
  try { j = JSON.parse(tile.contentJson); } catch (_) { return ''; }
  if (!j) return '';
  // 260910 유저 방향 전환 — 택1이 아니라 '카카오 주소가 있으면 카카오톡 버튼이 살아난다'. channel 키는 BE 검증기 호환용으로만 남는다.
  const u = String(j.kakaoUrl || '').trim();
  return /^https:\/\/(pf|open)\.kakao\.com\/.+/i.test(u) ? u : ''; // BE validateInquiryChannelJson과 동일(호스트 뒤 경로 필수)
};
// 260914 메가스터디 — 채널이 없는 사장의 **개인 카카오톡 ID**(대표 mega5721) {"kakaoId":"mega5721"}. 카카오톡은 개인 ID 로 곧장 여는 링크가 없어
//   (채널·오픈채팅·프로필 QR 링크만 가능) 랜딩은 'ID 복사 + 카카오톡 열기' 안내 시트로 받는다. 오픈채팅/프로필 링크가 오면 kakaoUrl 로 승격하면 원탭.
//   ⚠️값이 영문이라 번역기에 걸린다 — 랜딩은 원문(sourceLanding) 행에서 읽고, BE NON_TRANSLATABLE_KEYS 에도 kakaoId.
export const qrKakaoIdOf = tile => {
  if (!tile || !QR_KAKAO_CHANNEL_PLATFORMS.includes(tile.platform) || !tile.contentJson) return '';
  let j = null;
  try { j = JSON.parse(tile.contentJson); } catch (_) { return ''; }
  const id = String((j && j.kakaoId) || '').trim();
  return /^[A-Za-z0-9._-]{2,30}$/.test(id) ? id : '';
};

// 260721 대표 "밑에 준비 중 열어줘라" — 랜딩 하단 '준비 중' 티저의 업종별 노출 맵.
//   랜딩 응답은 숨김 타일을 안 내려서(includeHidden=false) FE가 category로 판단해야 함.
//   ⚠️BE QrTemplate.CATEGORY의 COMING_SOON 배치 미러 — 저쪽에 준비중 타일을 넣고 빼면 여기도 같이.
// 260722 시트5 #13/#24: 미용건강(시술중 안내)·매장/시설(고장신고·창업가맹·PET 시술중) 준비중 티저 노출 중단
export const QR_COMING_SOON_CATEGORY = {
  WAITING: ['FOOD', 'PUB'],
  // 260722 시트7 V14: DOORBELL 실구현으로 '준비 중' 티저 제거 — 사무·회사 카탈로그에서 정식 타일
};

// 260709 이름 고정 타일(대표: 이름=기능이라 커스텀하면 헷갈림) — 편집기에서 '버튼 이름' 입력 숨김
export const QR_TILE_FIXED_NAME = ['PHONE', 'BIZTALK', 'GANPANON', 'WIFI', 'TOILET', 'VCARD', 'SAVE_BIZ', 'RECRUIT', 'DAILY_VERSE'];

export const qrTileKind = platform => QR_TILE_KIND[platform] || 'TEXT';
export const qrTileFixedName = platform => QR_TILE_FIXED_NAME.includes(platform);

// 260713 타일별 편집기 예시(placeholder/hint) — 하나의 kind를 여러 업종이 공유하는데
//   예시가 한 업종에만 맞던 문제 전수 수정(사용자 지적: 모임일정에 '광어/국내산', 미용 가격표에 '아메리카노' 등).
//   필드 shape는 kind별로 다름 — TABLE={k,v} / MENU={name,price} / STAFF={role} / EVENT={title}.
export const QR_TILE_EXAMPLE = {
  // TABLE (항목/값 2열)
  ORIGIN_LABEL: { k: '광어', v: '국내산' },
  NON_COVERED: { k: '도수치료', v: '5만원' },
  DEPARTMENTS: { k: '내과', v: '평일 진료' },
  TUITION: { name: '종합반', price: '월 30만원' },
  SERVICE_TIME: { k: '주일예배', v: '오전 11시' },
  MEETING_TIME: { k: '정기모임', v: '매주 토요일 10시' },
  OFFERING: { k: '주일헌금', v: '국민 123-456 홍길동' },
  TRANSFER: { k: '입금 계좌', v: '국민 123-456 홍길동' },
  CHECKIN: { k: '체크인', v: '오후 3시부터' },
  ADMISSION: { k: '성인', v: '15,000원' },
  // MENU (품목·가격)
  MENU: { name: '아메리카노', price: '4,000원' },
  PRICE_MENU: { name: '커트', price: '20,000원' },
  // STAFF (직함)
  STAFF_INTRO: { role: '원장 / 디자이너' },
  PASTOR_INTRO: { role: '담임목사 / 전도사' },
  SMALL_GROUP: { role: '1구역 리더 / 셀 인도자' },
  CONTACTS: { role: '영업팀 과장' },
  // EVENT (제목)
  FIRST_EVENT: { title: '첫 방문 20% 할인' },
  EVENT_INFO: { title: '여름맞이 감사 이벤트' },
  TRIAL: { title: '무료 체험 수업' },
  CHURCH_EVENT: { title: '성탄 감사예배', period: '12/24 오후 7시' },
  SHOWTIME: { title: '저녁 공연', period: '매일 19:30' },
  ACADEMY_EVENT: { title: '여름방학 특강', period: '8/1 개강' } // 260825 학원 확장
};
// 필드 미정의 시 kind별 중립 기본값으로 폴백
const QR_EXAMPLE_FALLBACK = { k: '항목', v: '값', name: '이름', price: '가격', role: '직함', title: '제목' };
// Wave1(크로스컷②) 예시 (platform, category) 2차원 — 공유 kind 예시가 타 업종에 그대로 노출되던 결함('커트 20,000원'이 네일샵에)
const QR_TILE_EXAMPLE_BY_CATEGORY = {
  PRICE_MENU: {
    SKIN: { name: '이달의 아트', price: '40,000원' },
    PET: { name: '소형견 목욕', price: '25,000원' },
    STUDIO: { name: '프로필 촬영', price: '80,000원' }
  },
  TUITION: {
    GYM: { name: '1개월 이용권', price: '99,000원' },
    DOJANG: { name: '주 3회', price: '월 13만원' },
    ACADEMY_HOBBY: { name: '취미반 월 4회', price: '월 12만원' }
  },
  FIRST_EVENT: {
    CAFE: { title: '스탬프 10개 = 아메리카노 1잔' },
    PUB: { title: '첫 테이블 서비스 안주' },
    STORE: { title: '신상 입고 기념 10% 할인' }
  }
};
// 260724 카테고리 재정비 — category 인자엔 소분류 키가 들어오므로 템플릿그룹으로 리졸브(레거시 키는 identity)
export const qrTileExample = (platform, category) => ({
  ...QR_EXAMPLE_FALLBACK,
  ...(QR_TILE_EXAMPLE[platform] || {}),
  ...((QR_TILE_EXAMPLE_BY_CATEGORY[platform] || {})[qrTplOf(category)] || {})
});

// 260721 시간표 placeholder 업종 분기 — TIMETABLE은 4개 업종이 공유하는데 예시 어감이 다름(S7)
export const QR_TIMETABLE_EXAMPLE = {
  ACADEMY: '중등 수학 심화', ACADEMY_HOBBY: '성인 취미미술반', DOJANG: '유아부', GYM: '아침 요가'
};
export const qrTimetableExample = category => QR_TIMETABLE_EXAMPLE[qrTplOf(category)] || '수업 이름';

// 260721 업종별 타일 라벨 오버라이드(병렬 회의안 흡수) — 같은 platform도 업종마다 부르는 이름이 다름. 사장 커스텀 title이 항상 우선
// Wave1(기획서 크로스컷①): 라벨이 '눌러야 할 이유'까지 말해주게 전면 확장. HOURS는 랜딩 밴드 라벨에도 적용(비영리 업종 '영업시간' 어색함 해소)
export const QR_LABEL_BY_CATEGORY = {
  TIMETABLE: { GYM: '클래스 시간표', ACADEMY: '수업 시간표', ACADEMY_HOBBY: '클래스 일정', DOJANG: '수련 시간표' },
  // 260722 시트5 #17 대표컨펌: PHONE 오버라이드(FOOD '전화 주문·예약'·CAFE '케이크 예약·주문') 제거 — 기본 라벨로 전 업종 통일
  // 260722 시트7 B12 대표컨펌: 교회·단체만 예외 복원 — 주문·예약이 없는 업종이라 '전화'로(그 외 업종은 통일 라벨 유지)
  PHONE: { CHURCH: '전화', GROUP: '전화' },
  MENU: { PUB: '메뉴·주류' },
  // 260803 부장님 A라인 — 교회에서 '상담 신청'은 어휘가 안 맞는다.
  //   CHURCH 그룹엔 소분류가 '교회' 하나뿐이라 같은 M_ORG의 단체(협회·봉사·NGO)엔 안 샌다.
  CONSULT: { CHURCH: '중보기도(상담)요청' },
  // 260806 유저 — '기업 저장'이 대부분 업종에 안 맞는다("학원은 학원 저장, 뷰티는 샵 저장…").
  //   손님이 누르는 버튼이라 그 업소를 부르는 말로 준다. 키는 템플릿그룹(tpl) — 소분류는 qrTplOf가 리졸브한다.
  //   OFFICE(IT·광고·법률·금융·제조·건설 등 19개 소분류)만 '기업 저장'을 그대로 쓴다 — 여기선 그게 맞는 말이다.
  SAVE_BIZ: {
    CHURCH: '교회 저장', GROUP: '단체 저장',
    CLINIC: '병원 저장', PHARMACY: '약국 저장',
    ACADEMY: '학원 저장', ACADEMY_HOBBY: '학원 저장', DOJANG: '도장 저장', GYM: '헬스장 저장',
    FOOD: '가게 저장', CAFE: '카페 저장', PUB: '가게 저장',
    BEAUTY: '샵 저장', SKIN: '샵 저장', PET: '샵 저장',
    STORE: '판매점 저장', UNMANNED: '매장 저장', PLAY: '매장 저장',
    STUDIO: '작업실 저장', REPAIR: '수리점 저장', CAR: '정비소 저장', MOBILE: '업체 저장',
    REALTY: '부동산 저장', LODGING: '숙소 저장', CULTURE: '공연장 저장'
  },
  // 260803 부장님 A라인 — 병원은 '의료진', 공연은 '출연진'.
  //   CLINIC은 M_MEDICAL(병의원·치과·성형·피부·한의원) + M_PET의 동물병원까지인데 거기도 '의료진 소개'가 맞다.
  //   CULTURE는 M_CULTURE(공연장·전시관·영화관) + M_HOBBY의 체험·레저인데, 체험·레저엔 스태프 소개가 A라인에 없어 안 뜬다.
  STAFF_INTRO: { BEAUTY: '디자이너 소개', ACADEMY: '강사진 소개', ACADEMY_HOBBY: '강사진 소개', DOJANG: '강사진 소개', CLINIC: '의료진 소개', CULTURE: '출연진 소개' }, // 260722 시트5 #18
  TUITION: { ACADEMY: '수강료', ACADEMY_HOBBY: '수강료', DOJANG: '수강료' }, // 260722 시트5 #19 — GYM은 '수강료·이용권' 유지(이용권 어휘)
  // 260825 학원 확장 — 실적·커리큘럼·일정은 소분류 성격 따라 부르는 말이 갈린다(입시=합격, 예체능=수상, 도장=승급).
  //   오버라이드 문자열은 QrLandingI18n EXTRA_LABEL에 같은 한글 키로 짝 등록(누락=외국어 화면에 한글 잔류).
  RESULTS: { ACADEMY: '합격 실적', ACADEMY_HOBBY: '수상·입상 실적', DOJANG: '승급·대회 실적' },
  CURRICULUM: { DOJANG: '수련 과정', ACADEMY_HOBBY: '클래스 소개' },
  ACADEMY_EVENT: { DOJANG: '도장 일정' },
  COMPANY_NEWS: { ACADEMY: '학원 소식', ACADEMY_HOBBY: '학원 소식', DOJANG: '도장 소식' }, // 알림장 수요 흡수(더보기 담기용)
  // 260901 유저 — 개통해 보니 학원인데 '매장 Q&A'로 떴다. 도장도 '학원' 공용(호칭 통일 지시).
  // 260910 유저 "교회인데 왜 매장 Q&A야" — 교회·단체는 SAVE_BIZ와 같은 호칭 축('교회 저장'·'단체 저장'). i18n EXTRA_LABEL 짝 필수.
  FAQ: { ACADEMY: '학원 Q&A', ACADEMY_HOBBY: '학원 Q&A', DOJANG: '학원 Q&A', BEAUTY: '샵 Q&A', SKIN: '샵 Q&A', CHURCH: '교회 Q&A', GROUP: '단체 Q&A' }, // 260901 뷰티도 호칭 '샵' 축
  HOURS: { GROUP: '운영시간' }, // 260722 시트5 #30 — CHURCH는 영업시간 자체 미노출로 전환(오버라이드 잔재 제거)
  // 260724 카테고리 재정비 — 신규 템플릿그룹 4종(키는 그룹 기준, 소분류는 qrTplOf 리졸브 후 조회)
  // 260803 부장님 A라인 — 교육은 '가격표'가 아니라 '수강료'.
  //   ⚠️DOJANG은 M_EDU(태권도·검도·유도)와 M_SPORTS(복싱)에 걸쳐 있다. 유저 판단으로 복싱장도 포함(도장·체육관은 수강료를 받는다).
  //   ⚠️같은 교육 그룹에서 TUITION(수강료·이용권)도 '수강료'로 뜬다 — 시트13 A라인엔 TUITION이 없어
  //     둘이 같이 보일 일은 없지만, 카탈로그 필터가 TUITION을 열어주면 이름이 겹친다(세션1 확인 필요).
  PRICE_MENU: { PLAY: '이용 요금', CAR: '정비·서비스 요금', ACADEMY: '수강료', ACADEMY_HOBBY: '수강료', DOJANG: '수강료' },
  GALLERY: { PLAY: '시설 사진', LODGING: '객실·시설 사진' },
  RESERVATION: { LODGING: '예약하기', CULTURE: '예매하기' },
  GROUP_INQUIRY: { PLAY: '단체·파티 문의' },
  // 260803 교회↔단체 분리 — 단체(협회·봉사단체·NGO) 기본 세트에 회사소개를 쓰는데 산악회에 '회사 소개'는 어색하다.
  //   대표 "이름이 애매하면 그 자체가 결함"(260803). BE A_ORG(단체용 프로파일)와 짝.
  // 260810 유저 — "식당이면 가게 소개, 학원이면 학원 소개로 가야". '가게 저장'(SAVE_BIZ)과 어휘 통일.
  //   미지정 tpl(OFFICE·STUDIO·REALTY·CULTURE 등)은 기본 '회사 소개' 유지.
  COMPANY_INTRO: {
    GROUP: '단체 소개',
    CHURCH: '교회 소개', // 260810 유저 — 교회 홈페이지에 '회사 소개' 폴백이 뜨던 것

    FOOD: '가게 소개', CAFE: '가게 소개', PUB: '가게 소개', STORE: '가게 소개',
    UNMANNED: '가게 소개', BEAUTY: '가게 소개', SKIN: '가게 소개', PET: '가게 소개', PLAY: '가게 소개',
    ACADEMY: '학원 소개', ACADEMY_HOBBY: '학원 소개', DOJANG: '도장 소개',
    CLINIC: '병원 소개', PHARMACY: '약국 소개',
    GYM: '센터 소개', LODGING: '숙소 소개',
    CAR: '업체 소개', REPAIR: '업체 소개', MOBILE: '업체 소개'
  }
};
// 260814 시트20 — '행사 진행'을 업종군별로 3분화. tpl 축으론 불가(OFFICE가 소비자·기업 양측에 걸침)라
//   대분류(major) 축 사전을 신설한다. 기본 라벨(QR_PLATFORM_META)이 소비자용 '할인행사/이벤트'고,
//   기업형 6개 대분류만 여기서 '기업행사/할인행사/이벤트'로 덮는다. 무인매장은 짧게 '행사/이벤트'.
//   교회는 전용 플랫폼(CHURCH_EVENT '교회 행사')이 따로 있어 이 사전과 무관.
//   ⚠️독서실·스터디카페(UNMANNED tpl, M_EDU 소속)가 tpl 사전이었으면 '행사/이벤트'로 샜다 — major 축인 이유.
export const QR_LABEL_BY_MAJOR = {
  EVENT_INFO: {
    M_LAW: '기업행사/할인행사/이벤트', M_FINANCE: '기업행사/할인행사/이벤트',
    M_MFG: '기업행사/할인행사/이벤트', M_BUILD: '기업행사/할인행사/이벤트',
    M_FRANCHISE: '기업행사/할인행사/이벤트', M_ETC: '기업행사/할인행사/이벤트',
    M_UNMAN: '행사/이벤트'
  },
  // 260903 전문직 사무실 라인(세무·회계·법무·변호사·노무) — 여기도 major 축인 이유는 위와 같다.
  //   tpl 'OFFICE'를 제조·유통·무역·건설·물류·IT·광고·인쇄·유튜브 등 19개 소분류가 공유해서,
  //   tpl 사전에 '사무실 소개'를 넣으면 공장·유튜버 화면까지 같이 바뀐다. M_LAW는 PRO_LAW·PRO_TAX·PRO_LABOR 셋뿐.
  //   ⚠️여기 넣은 한글 문자열은 QrLandingI18n EXTRA_LABEL에 같은 한글 키로 짝 등록(누락=외국어 화면에 한글 잔류).
  SAVE_BIZ: { M_LAW: '사무실 저장' },        // tpl 사전은 OFFICE를 '기업 저장'으로 두는 게 맞다(제조·무역) — 사무실만 뗀다
  FAQ: { M_LAW: '사무실 Q&A' },              // 기본 '매장 Q&A'
  COMPANY_INTRO: { M_LAW: '사무실 소개' }    // 기본 '회사 소개'
  // ⚠️HOURS는 여기 넣어도 소용없다 — 영업시간은 큐브 타일에서 통째로 제외되고(QrLanding:255,
  //   QrManage:452·687) 히어로에 라벨 없이 값만 그린다. qrTileLabelFor를 타는 렌더러가 없다.
};
export const qrTileLabelFor = (platform, category, fallback) =>
  (QR_LABEL_BY_CATEGORY[platform] || {})[qrTplOf(category)] ||
  (QR_LABEL_BY_MAJOR[platform] || {})[(qrCategoryMeta(category) || {}).group] ||
  fallback;

// 261015 대표 시안2(버튼 아이콘 전면 재구성) — 같은 버튼도 업종에 따라 그림이 달라야 바로 읽히는 것.
//   값 = tiles/<값>.png 파일 이름. 위 라벨 사전과 같은 축(tpl): 학원 '학원 소개' = 학사모, 교회 '교회 소개' = 교회.
//   도장('도장 소개')은 학사모가 맞지 않아 기본 그림. 그림 파일이 꼭 있어야 한다(tests/qr/qrTileIcons.test.mjs).
export const QR_TILE_ICON_BY_CATEGORY = {
  COMPANY_INTRO: { ACADEMY: 'academy_intro', ACADEMY_HOBBY: 'academy_intro', CHURCH: 'church_intro' }
};
// contentJson.icon 처럼 이미 파일 이름(소문자)인 값은 사전에 없어 그대로 돌려준다.
export const qrTileIconFor = (platform, category) =>
  (QR_TILE_ICON_BY_CATEGORY[platform] || {})[qrTplOf(category)] || platform;

// 260811 유저 — "선택된 항목이 교인 분들께 노출됩니다"처럼 **보는 사람**을 업종 말로 부른다.
//   교회에 '손님', 병원에 '손님'은 어색하다. 키는 위 사전과 같은 템플릿그룹(tpl).
//   여기 없는 업종은 '손님' — 가장 넓게 통하는 기본값이라 빠져도 문장이 깨지지 않는다.
export const QR_AUDIENCE_BY_TPL = {
  CHURCH: '교인', GROUP: '회원',
  CLINIC: '환자', PHARMACY: '손님',
  ACADEMY: '수강생', ACADEMY_HOBBY: '수강생', DOJANG: '수련생', GYM: '회원',
  CULTURE: '관객', LODGING: '고객',
  REALTY: '고객', OFFICE: '고객', REPAIR: '고객', CAR: '고객', MOBILE: '고객', STUDIO: '고객'
};
export const qrAudienceOf = category => QR_AUDIENCE_BY_TPL[qrTplOf(category)] || '손님';

// 260811 유저 — 개통 2단계에서 '사업장 정보'·'가게(회사) 이름'이 교회엔 안 맞는다("교회 정보"·"교회 이름").
//   업소를 부르는 말. SAVE_BIZ 라벨과 같은 명칭 체계지만 그 사전은 버튼 문구용이라
//   ' 저장'을 문자열로 떼어 쓰지 않고 별도로 둔다(문구가 바뀌면 조용히 깨진다).
//   여기 없으면 빈 문자열 — 호출부가 기존 문구('사업장'·'가게(회사)')로 폴백한다.
export const QR_PLACE_BY_TPL = {
  CHURCH: '교회', GROUP: '단체',
  CLINIC: '병원', PHARMACY: '약국',
  ACADEMY: '학원', ACADEMY_HOBBY: '학원', DOJANG: '도장', GYM: '헬스장',
  FOOD: '가게', CAFE: '카페', PUB: '가게',
  BEAUTY: '샵', SKIN: '샵', PET: '샵',
  STORE: '판매점', UNMANNED: '매장', PLAY: '매장',
  STUDIO: '작업실', REPAIR: '수리점', CAR: '정비소', MOBILE: '업체',
  REALTY: '부동산', LODGING: '숙소', CULTURE: '공연장', OFFICE: '회사'
};
// 260903 전문직 사무실 라인 — tpl 'OFFICE'는 '회사'가 맞는 소분류(제조·무역·건설·IT)와 같이 쓰는 칸이라
//   덮으면 샌다. 대분류 축으로 법률/세무만 '사무실'. 위 QR_LABEL_BY_MAJOR와 같은 이유·같은 축.
export const QR_PLACE_BY_MAJOR = { M_LAW: '사무실' };
// ⚠️major를 **먼저** 본다. qrTileLabelFor(tpl 먼저)와 순서가 반대인 건 의도다 —
//   저쪽 tpl 사전(QR_LABEL_BY_CATEGORY)엔 OFFICE 키가 없지만 이쪽 QR_PLACE_BY_TPL엔 OFFICE:'회사'가
//   이미 있어서, tpl을 먼저 보면 '회사'가 항상 이겨 M_LAW 행이 죽은 분기가 된다.
export const qrPlaceOf = category =>
  QR_PLACE_BY_MAJOR[(qrCategoryMeta(category) || {}).group]
  || QR_PLACE_BY_TPL[qrTplOf(category)]
  || '';

// 260903 전문직 사무실 라인 — 손님 화면이 업주를 부르는 말('사장님이 확인 후 연락드립니다', '사장님이 경품을 준비').
//   여태 QrGamePage·QrLanding이 각자 3항 삼항으로 들고 있던 걸 한 곳으로 모은다(호칭 사전은 이미 3개나 갈라져 있다).
//   학원 계열은 '원장님'(260901 호칭 통일 지시와 같은 축), 법률/세무는 '대표님', 그 외는 '사장님'.
export const qrOwnerNoun = category => {
  const tpl = qrTplOf(category);
  if (['ACADEMY', 'ACADEMY_HOBBY', 'DOJANG'].includes(tpl)) return '원장님';
  if ((qrCategoryMeta(category) || {}).group === 'M_LAW') return '대표님';
  return '사장님';
};

// 260804 유저 — 전화 큐브가 번호 하나만 받아 '교회 대표번호'와 '목사님 번호'를 같이 못 걸었다.
//   두 칸으로 늘리면서 이름도 업종 어휘로 준다("회사 전화/개인 전화, 교회 전화/목사님 전화, 사무실/담당자").
//   [0]=조직 번호(기본정보 bizPhone과 같은 진원) / [1]=사람 번호(PHONE 타일 contentJson.phone2).
//   ⚠️키는 템플릿그룹(tpl) 기준 — 소분류로 조회하면 안 맞는다. qrPhoneLabels가 qrTplOf로 리졸브한다.
const QR_PHONE_LABEL_FALLBACK = ['대표 전화', '담당자 전화'];
export const QR_PHONE_LABELS = {
  CHURCH: ['교회 전화', '목사님 전화'],
  GROUP: ['단체 전화', '담당자 전화'],
  OFFICE: ['회사 전화', '담당자 전화'],
  CLINIC: ['병원 전화', '담당자 전화'],
  PHARMACY: ['약국 전화', '약사님 전화'],
  ACADEMY: ['학원 전화', '원장님 전화'],
  ACADEMY_HOBBY: ['학원 전화', '원장님 전화'],
  DOJANG: ['도장 전화', '관장님 전화'],
  GYM: ['센터 전화', '담당자 전화'],
  // 260805 정리(14) 요식#1 — 부장 지정: '가게 전화' → '매장(사업장) 전화'. 요식/카페 행 지시라 REPAIR는 그대로 뒀다.
  FOOD: ['매장(사업장) 전화', '사장님 전화'],
  CAFE: ['매장(사업장) 전화', '사장님 전화'],
  PUB: ['매장(사업장) 전화', '사장님 전화'],
  BEAUTY: ['매장 전화', '원장님 전화'],
  SKIN: ['매장 전화', '원장님 전화'],
  STORE: ['매장 전화', '사장님 전화'],
  UNMANNED: ['매장 전화', '사장님 전화'],
  STUDIO: ['작업실 전화', '사장님 전화'],
  PET: ['매장 전화', '담당자 전화'],
  REALTY: ['사무소 전화', '중개사 전화'],
  REPAIR: ['가게 전화', '사장님 전화'],
  MOBILE: ['대표 전화', '기사님 전화'],
  PLAY: ['매장 전화', '담당자 전화'],
  CAR: ['정비소 전화', '사장님 전화'],
  LODGING: ['숙소 전화', '사장님 전화'],
  CULTURE: ['공연장 전화', '담당자 전화']
};
// 260903 전문직 사무실 — tpl 사전은 OFFICE를 '회사 전화'로 두는 게 맞다(제조·무역·건설).
//   법률/세무만 '사무실 전화'로. qrPlaceOf와 같은 이유로 major를 먼저 본다(tpl에 OFFICE 키가 이미 있다).
const QR_PHONE_LABELS_BY_MAJOR = { M_LAW: ['사무실 전화', '담당자 전화'] };
export const qrPhoneLabels = category =>
  QR_PHONE_LABELS_BY_MAJOR[(qrCategoryMeta(category) || {}).group]
  || QR_PHONE_LABELS[qrTplOf(category)]
  || QR_PHONE_LABEL_FALLBACK;

// 260721 시간표 업종별 프리셋 스캐폴드(병렬 회의안 흡수) — 빈 편집기에 반 이름을 미리 깔아준다("사용자가 공부하면 망한다"), 사장은 요일·시간만 고름
export const QR_TIMETABLE_PRESET = {
  GYM: ['오전반', '저녁반', '주말반'],
  ACADEMY: ['초등부', '중등부', '고등부'],
  ACADEMY_HOBBY: ['유아·초등', '중·고등', '성인'],
  DOJANG: ['유치부', '초등부', '중·고등부', '성인부']
};
export const qrTimetablePreset = category => QR_TIMETABLE_PRESET[qrTplOf(category)] || [];

// 260825 학원 확장 — 커리큘럼(CLASSES kind) 부(학년 그룹) 스캐폴드. 시간표 프리셋과 어휘 통일(시간표=시간/수강료=가격/커리큘럼=내용이 같은 부 이름을 쓰게)
export const QR_CLASSES_PRESET = {
  ACADEMY: ['초등부', '중등부', '고등부'],
  ACADEMY_HOBBY: ['유아·초등', '중·고등', '성인'],
  DOJANG: ['유치부', '초등부', '중·고등부', '성인부']
};
export const qrClassesPreset = category => QR_CLASSES_PRESET[qrTplOf(category)] || [];

// Wave1(크로스컷③) 한줄공지·첫방문이벤트 프리셋 문구 칩 — 빈 입력창 대신 탭 한 번(업종 어휘 미리 깔기)
export const QR_NOTICE_CHIPS = {
  FOOD: ['재료 소진 시 조기 마감합니다', '오늘 휴무입니다', '점심 웨이팅 있어요'],
  CAFE: ['갓 구운 빵 오전 11시에 나와요', '케이크 예약은 전화 주세요', '노트북 이용 가능해요'],
  PUB: ['오늘 21시 축구 중계합니다 🖥️', '단체석 문의 환영', '오늘 휴무입니다'],
  BEAUTY: ['오늘 예약 마감됐어요', '당일 예약 문의 주세요'],
  SKIN: ['오늘 예약 마감됐어요', '당일 예약 문의 주세요'],
  UNMANNED: ['정상 운영 중입니다', '점검 중 — 잠시 이용이 어려워요'],
  PHARMACY: ['상비약·마스크 재고 있습니다', '오늘 야간 운영해요'],
  // 260724 카테고리 재정비 — 신규 템플릿그룹 4종
  PLAY: ['지금 자리 여유 있습니다', '단체·파티 예약 환영'],
  LODGING: ['오늘 빈 객실 있어요', '예약 문의는 전화 주세요'],
  CULTURE: ['오늘 현장 입장 가능합니다', '매주 월요일은 쉬어요'],
  CAR: ['예약 없이 방문 가능합니다', '오늘 정비 예약 마감됐습니다']
};
// 261026 주차판 차주 안내 문구 가이드(QR_PARKING_NOTICE_PRESETS)는 기능째 뺐다(대표 회의 #7·유저 "로직 자체를 없애버려").
export const QR_EVENT_CHIPS = {
  CAFE: ['텀블러 지참 500원 할인', '스탬프 10개 = 아메리카노 1잔', '리뷰 이벤트 진행 중'],
  PUB: ['첫 테이블 서비스 안주', '생일자 하이볼 1잔', '단체 10인 이상 서비스'],
  FOOD: ['첫 방문 음료 서비스', '리뷰 남기면 사이드 서비스'],
  BEAUTY: ['첫 방문 20% 할인', '친구랑 오면 둘 다 10% 할인'],
  STORE: ['신상 입고 기념 10% 할인'],
  // 260724 카테고리 재정비
  PLAY: ['평일 낮 시간 20% 할인'],
  LODGING: ['연박 할인 진행 중'],
  CULTURE: ['조조·평일 할인'],
  CAR: ['엔진오일 교환 이벤트']
};
export const qrNoticeChips = category => QR_NOTICE_CHIPS[qrTplOf(category)] || [];
export const qrEventChips = category => QR_EVENT_CHIPS[qrTplOf(category)] || [];

// Wave1(크로스컷④) 메뉴·표 프리셋 스캐폴드 — QR_TIMETABLE_PRESET 패턴 확장. 사장은 가격/값만 채움.
//   ⚠️프리셋 행은 _preset 마킹 — 값 미입력이면 저장에서 제외(cleanModel)해 '소주 ₩빈칸' 어설픈 노출 방지.
export const QR_MENU_PRESET = { // MENU kind(items.name) — platform→category
  MENU: { PUB: ['소주', '맥주', '하이볼', '막걸리'] },
  PRICE_MENU: { BEAUTY: ['커트', '펌', '염색', '클리닉'], SKIN: ['젤네일', '속눈썹 연장', '왁싱'] }
};
// 260729 #9 — 수강료 전용 kind로 분리되며 TABLE 프리셋에서 이관(이름 목록은 그대로)
export const QR_TUITION_PRESET = { GYM: ['1개월 이용권', '3개월 이용권', '6개월 이용권'], DOJANG: ['주 2회', '주 3회', '주 5회'], ACADEMY: ['초등부', '중등부', '고등부'] };
export const qrTuitionPreset = category => QR_TUITION_PRESET[qrTplOf(category)] || [];

export const QR_TABLE_PRESET = { // TABLE kind(rows.k) — platform→category
  SERVICE_TIME: { CHURCH: ['주일 1부 예배', '주일 2부 예배', '수요 예배', '금요 기도회'] },
  OFFERING: { CHURCH: ['주일헌금', '십일조', '감사헌금'] },
  TRANSFER: { OFFICE: ['입금 계좌'], STORE: ['입금 계좌'], REPAIR: ['입금 계좌', '예약금 계좌'] },
  MEETING_TIME: { GROUP: ['정기 모임', '임원 회의'] },
  // 260724 카테고리 재정비 — 신규 타일 프리셋
  CHECKIN: { LODGING: ['체크인', '체크아웃', '늦은 퇴실(문의)'] },
  ADMISSION: { CULTURE: ['성인', '청소년', '어린이'], PLAY: ['1시간 이용', '종일권'] }
};
export const qrMenuPreset = (platform, category) => (QR_MENU_PRESET[platform] || {})[qrTplOf(category)] || [];
export const qrTablePreset = (platform, category) => (QR_TABLE_PRESET[platform] || {})[qrTplOf(category)] || [];

// 260803 대표 — 주보(BULLETIN) 직접 타이핑 기본 틀. 사진 촬영만 되던 탓에 '이번 주 말씀' 같은
//   기본 틀을 못 쓰던 걸 푼다. QR_TABLE_PRESET과 같은 _preset 관례 — 내용 안 채운 칸은 저장에서 빠진다.
// 260804 유저 — 기본 틀을 '설교 제목·설교 내용·교회 소식'으로 교체. 온라인 주보에서 손님이 실제로
//   찾는 건 예배 순서표가 아니라 그 주 설교와 소식이다. 기존 저장분(sections 있음)은 안 건드린다.
export const QR_BULLETIN_PRESET = ['설교 제목', '설교 내용', '교회 소식'];
export const QR_BULLETIN_PLACEHOLDER = {
  '설교 제목': '예) 하나님이 세상을 이처럼 사랑하사',
  '설교 내용': '예) 요한복음 3장 16절 — 하나님이 세상을 이처럼 사랑하사 독생자를 주셨으니…',
  '교회 소식': '예) 다음 주 성찬식 / 새가족 환영회 · 주일 오후 2시 교육관'
};

// 260803 대표 — 목사님 소개에 교단 선택 필수("이름만 있으면 어느 교단인지 알 수 없다").
//   260803 유저: 직접 입력은 뺀다 — 자유 입력이면 같은 교단이 표기만 달리 쌓여 목록의 의미가 없어진다.
//   목록에 없는 교단 요청이 오면 이 배열에 추가하는 방식으로 관리한다.
export const QR_DENOMINATIONS = ['장로교', '감리교', '성결교', '순복음', '침례교', '루터교', '성공회', '구세군', '독립교회'];

// Wave1(크로스컷⑤) 주문하기 통합 큐브(ORDER_HUB) — 배달·주문 링크 6종의 개별 큐브 도배를 렌더 레벨에서 봉인.
//   FE 전용 가상 타일(BE 행 없음) — 아래 플랫폼 중 링크 채워진 게 1개 이상이면 큐브 하나로 묶어 바텀시트 진입.
export const QR_ORDER_HUB_PLATFORMS = ['NAVER_ORDER', 'KAKAO_ORDER', 'BAEMIN', 'YOGIYO', 'COUPANG_EATS', 'DELIVERY'];

// 260811 유저 — 가게 밖에 붙은 QR을 찍는 사람의 목적은 대개 '메뉴/가격이 뭐냐'다.
//   그래서 메뉴판·가격표는 간판온·저장 다음 자리로 끌어올린다(렌더 순서만. 타일 스키마·저장값 불변).
//   ⚠️읽는 곳이 두 군데다 — QrLanding cubeTiles(손님 화면)와 QrManage customerOrderTiles(사장 미리보기).
//     한쪽만 고치면 사장이 보는 순서와 손님이 보는 순서가 어긋난다(260805에 같은 계약으로 이미 한 번 물림).
export const QR_TOP_PIN_PLATFORMS = ['MENU', 'PRICE_MENU'];

// 261015 대표 시안2·시안1 — 손님 버튼을 '큰 6칸(3×2) + 아래 스와이프 줄'로 나눈다(유저 선택 '전화·상담·오시는 길 우선').
//   tiles = 손님 화면 순서(QrLanding cubeTiles 정렬 — 간판ON·저장·회원가입 고정 → 메뉴판 → 사장님 순서) 그대로 받는다.
//   큰 칸 자리는 시안2 그대로: 1번 전화(파란 칸), 3번 상담(문의형 버튼 — 카카오톡 연결된 것 우선, 연결돼 있으면 노란 칸), 6번 오시는 길.
//   빈 자리·없는 자리는 남은 버튼을 지금 순서대로 채우고, 6칸이 넘는 나머지는 아래 줄. 간판ON·저장·회원가입은 아래 줄 맨 앞.
//   isLive = 내용이 있고 준비 중이 아닌가 — 아닌 전화·상담·지도는 우선 자리·색 칸에 올리지 않는다(파란 칸이 비어 보이면 안 된다).
//   tests/qr/qrTileLayout.test.mjs
export const QR_SMALL_FIRST_PLATFORMS = ['GANPANON', 'SAVE_BIZ', 'SIGNUP'];
// 상담 자리 후보 순서 — 카카오톡 연결이 먼저, 같으면 상담 신청 → 문의 남기기 → 그 밖의 문의.
//   카톡 주소는 현판 단위라(문의형 한 칸에 넣으면 전부 카톡 — QrLanding kakaoUrlOf) 대개 다 같이 카톡이다.
//   그때 사장님 순서만 보면 '레벨테스트 신청'이 노란 TALK 칸이 된다(261015 메가스터디 실측).
const QR_CONSULT_ORDER = ['CONSULT', 'BIZTALK', 'QUOTE', 'GROUP_INQUIRY', 'LEVEL_TEST'];
export const qrTileLayout = (tiles = [], { isLive = () => true, isKakao = () => false } = {}) => {
  const head = tiles.filter(t => QR_SMALL_FIRST_PLATFORMS.includes(t.platform));
  const rest = tiles.filter(t => !QR_SMALL_FIRST_PLATFORMS.includes(t.platform));
  const phone = rest.find(t => t.platform === 'PHONE' && isLive(t));
  const rank = t => (isKakao(t) ? 0 : QR_CONSULT_ORDER.length) + QR_CONSULT_ORDER.indexOf(t.platform);
  const consult = rest
    .filter(t => QR_CONSULT_ORDER.includes(t.platform) && isLive(t))
    .sort((a, b) => rank(a) - rank(b))[0];
  const map = rest.find(t => t.platform === 'MAP' && isLive(t));
  const others = rest.filter(t => t !== phone && t !== consult && t !== map);
  const big = [];
  let next = 0;
  [phone, null, consult, null, null, map].forEach(fixed => {
    if (fixed) big.push(fixed);
    else if (next < others.length) big.push(others[next++]);
  });
  return {
    big,
    small: [...head, ...others.slice(next)],
    blue: phone || null,
    yellow: consult && isKakao(consult) ? consult : null,
    // 규칙이 자리를 정한 칸(전화·상담·오시는 길) — 사장님 순서와 상관없이 그 자리라 관리 화면에서 옮길 수 없다.
    placed: [phone, consult, map].filter(Boolean)
  };
};

// 261015 대표님 철학 '사장님도 손님이 보는 화면 그대로 봐야 헷갈리지 않는다' — 손님 화면(QrLanding)과
//   관리자 화면 '현재 노출 중'(QrManage)이 버튼 자리를 이 한 곳에서 나눈다. 두 화면이 따로 계산하면 언젠가 어긋난다(260805에 한 번 물림).
//   tiles = 손님 화면 순서로 정렬된 칸(QrLanding cubeTiles·QrManage customerOrderTiles 정렬).
//   isReady = 내용이 있어 손님이 쓸 수 있는가 / isPreparing = '준비 중' 표식 / isFeatured = 버튼 위 큰 배너 / isWide = 한 줄 통째 칸 / isAd = 광고판으로 나가는 칸.
//   돌려주는 것: ad · featured(배너) · wide(한 줄 칸) · qrTileLayout 결과(big·small·blue·yellow·placed) · admin(내용이 비어 '관리자용'에 모이는 칸).
//   tests/qr/qrTileLayout.test.mjs
export const qrCustomerZones = (tiles = [], {
  isReady = () => true, isPreparing = () => false, isFeatured = () => false, isWide = () => false, isAd = () => false, isKakao = () => false
} = {}) => {
  const ad = tiles.find(isAd) || null;
  const shown = t => (isReady(t) || isPreparing(t)) && t !== ad;
  const customer = tiles.filter(t => shown(t) && !isFeatured(t));
  return {
    ad,
    featured: tiles.filter(t => shown(t) && isFeatured(t)),
    wide: customer.filter(isWide),
    ...qrTileLayout(customer.filter(t => !isWide(t)), { isLive: t => isReady(t) && !isPreparing(t), isKakao }),
    admin: tiles.filter(t => !isReady(t) && !isPreparing(t))
  };
};

// 260730 시트9 텍스트 #32·37·42·45·48·53 + 버그#13 — 영업시간 부가항목(브레이크타임·라스트오더)은
//   업종마다 의미가 다르다. '라스트오더'는 주문받는 업종의 어휘고, 예약 업종은 '예약마감'이 맞다.
//   사무·전문·제조·문화 등엔 둘 다 무의미해 부장님이 삭제를 요청했다.
//   break=브레이크타임 노출 / lastOrder=라스트오더 라벨(null이면 숨김). 26 대분류 전부 명시(기본값 폴백 금지 —
//   신규 대분류가 생겼을 때 조용히 잘못 노출되는 걸 막는다).
export const QR_HOURS_EXTRAS = {
  // 주문형 — 원래 용도 그대로
  M_FOOD:      { break: true,  lastOrder: '라스트오더' },
  // 예약형 — 점심 휴게는 있고, 마감은 '예약마감'
  M_BEAUTY:    { break: true,  lastOrder: '예약마감' },
  M_MEDICAL:   { break: true,  lastOrder: '예약마감' },
  M_SPORTS:    { break: true,  lastOrder: '예약마감' },
  M_PET:       { break: true,  lastOrder: '예약마감' },
  M_CRAFT:     { break: true,  lastOrder: '예약마감' }, // 261103 공방/클래스 — 클래스는 예약제(팀장 '제안대로')
  // 휴게만 — 점심시간은 있으나 주문·예약 마감 개념이 없음
  M_AUTO:      { break: true,  lastOrder: null },
  M_LODGING:   { break: true,  lastOrder: null },
  M_LIFE:      { break: true,  lastOrder: null },
  M_RETAIL:    { break: true,  lastOrder: null },
  M_APPAREL:   { break: true,  lastOrder: null },
  M_CULTURE:   { break: true,  lastOrder: null },
  M_WEDDING:   { break: true,  lastOrder: null },
  M_HOBBY:     { break: true,  lastOrder: null },
  M_FRANCHISE: { break: true,  lastOrder: null },
  // 둘 다 숨김 — 교육·사무·전문·제조(부장님 명시)
  M_EDU:       { break: false, lastOrder: null },
  M_IT:        { break: false, lastOrder: null },
  M_LAW:       { break: false, lastOrder: null },
  M_FINANCE:   { break: false, lastOrder: null },
  M_ADS:       { break: false, lastOrder: null },
  M_MEDIA:     { break: false, lastOrder: null },
  M_REALTY:    { break: false, lastOrder: null },
  M_BUILD:     { break: false, lastOrder: null },
  M_INTERIOR:  { break: false, lastOrder: null },
  M_MFG:       { break: false, lastOrder: null },
  M_ORG:       { break: false, lastOrder: null }, // 교회는 영업시간 자체 미노출(시트5 #30)
  M_ETC:       { break: true,  lastOrder: null }
};
// 무인매장(tpl UNMANNED)은 대분류와 무관하게 둘 다 숨김 — 260729 버그#13 선반영분 유지
export const qrHoursExtras = (major, tpl) => (tpl === 'UNMANNED'
  ? { break: false, lastOrder: null }
  : (QR_HOURS_EXTRAS[major] || { break: true, lastOrder: '라스트오더' }));

// 260721 매물 표기 헬퍼 — QrManage 미리보기·QrLanding 카드 공용. 만원 숫자 → '3억 5,000만원'
export const qrFmtManwon = v => {
  const n = parseInt(String(v || '').replace(/[^0-9]/g, ''), 10);
  if (!n) return '';
  const eok = Math.floor(n / 10000), man = n % 10000;
  if (!eok) return `${man.toLocaleString()}만원`;
  return man ? `${eok}억 ${man.toLocaleString()}만원` : `${eok}억`;
};
// 260729 시트9 버그#6 — 메뉴 가격이 입력값 그대로 찍혀 '12000'처럼 보였다(부장님: 원 붙이고 천원 단위 콤마).
//   가격표 토핑이 멀쩡했던 건 사람이 '20,000원'을 직접 타이핑했기 때문 — AI 판독분은 숫자만 들어온다.
//   저장값은 건드리지 않고 표시 직전에만 다듬는다. 숫자 외 글자가 섞인 값('시가', '3,000원~', '1인 15,000')은
//   사장이 의도한 표기라 원문 그대로 둔다.
export const qrFmtPrice = v => {
  const s = String(v == null ? '' : v).trim();
  if (!s) return '';
  if (!/^[0-9,\s]+$/.test(s)) return s;            // 숫자·콤마·공백만인 값에만 개입
  const n = parseInt(s.replace(/[^0-9]/g, ''), 10);
  if (!Number.isFinite(n)) return s;
  return `${n.toLocaleString()}원`;
};

// 평↔㎡ 자동 환산 병기 (1평=3.305785㎡, 소수 1자리)
export const qrAreaBoth = (value, unit) => {
  const v = parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
  if (!v) return '';
  return unit === '㎡' ? `${v}㎡ (${(v / 3.305785).toFixed(1)}평)` : `${v}평 (${(v * 3.305785).toFixed(1)}㎡)`;
};

// 260710 대표 컨펌 — 설치 신청 폼 폐기, 스마트스토어 직연결(스토어 결제 취소→앱 재주문 우회 방지).
// ⚠️ 실제 스토어 주소 확정 시 이 한 곳만 교체(진입점 전부 이 상수 소비).
export const QR_SMARTSTORE_URL = 'https://smartstore.naver.com/ganpanon';

// 260714 편의 오브제(대표 회의) — 가게 현판과 별개로 붙이는 품목 전용 QR(주차판·펫 네임택 등).
//   주차·강아지 네임택·어르신 안심태그 3종. key = tblQrAsset.qrType 값과 1:1
//   (PETTAG=반려동물 네임택 — 업종 카테고리 'PET'[반려동물 업종]과 저장 컬럼·의미가 다름).
//   buyNotice = 관리 화면 구매 시트 안내(오브제별). 타일이 아니라 별도 QR(매장 QR은 차·목걸이에 못 붙임).
export const QR_CONVENIENCE_ITEMS = [
  {
    key: 'PARKING',
    icon: '🅿️',
    label: '주차 안심연락',
    // 261102 유저 '고쳐줘'(대표님 '말이 이상하다') — 홈·정품등록 라인업과 같은 말로(해요체 'QR로 스캔하면 … 있어요' → 'QR을 찍으면 … 있습니다').
    desc: '차 앞 유리 QR을 찍으면 차주에게 바로 연락할 수 있습니다.',
    buyLabel: '주차QR 구매하기',
    // 260720 #54(3) 대표 — 주차 안내 시트도 '작은 박스'(buyNotice) 없이 위 문구(desc)만(어르신 #58과 통일). buyNotice 미지정 → 시트가 박스 미렌더(v-if).
    registerPath: '/more/qr-parking'
  },
  {
    key: 'PETTAG',
    icon: '🐶',
    label: '반려동물 목걸이 인식표',
    // 261102 같은 까닭 — '반려동물, 이름, 특이사항이 … 주인에게' → 홈 라인업과 같은 말('보호자').
    desc: 'QR을 찍으면 반려동물 이름과 특이사항이 보이고, 보호자에게 바로 연락할 수 있습니다.',
    buyLabel: '목걸이 인식표 구매하기',
    buyNotice: '🐶 전용 오브제(반려동물 목걸이 인식표)가 필요합니다. 목걸이·인식표에 다는 QR입니다. 목걸이 인식표를 구매한 뒤 등록하면 바로 쓸 수 있습니다.',
    registerPath: '/more/qr-pet'
  },
  {
    key: 'DEMENTIA',
    icon: '🧡',
    label: '어르신 안심태그',
    // 260716 [PLACEHOLDER 문구 — 최종 카피 나영] 치매·인지저하 어르신 배회 대비 안심태그(펫 네임택 틀 복제)
    // 261007 특허 사전조사 — '옷'에 붙이는 QR 은 등록특허 10-1465110(QR 인쇄 의류 미아방지)과 가까워 빼고 목걸이·지갑·가방으로.
    // 261102 main 이식 — dev 최종본 문구로 맞춤('번호 노출 없이'는 10/01 dev 에서 정정: 실제로는 전화 버튼이 있다).
    desc: '어르신 목걸이·지갑·가방에 다는 QR입니다. 스캔하면 보호자에게 바로 알림이 가고, 전화로도 연락할 수 있습니다.',
    buyLabel: '안심태그 구매하기',
    // 260720 #58 대표 — 어르신 안내 시트는 '작은 박스'(buyNotice) 없이 위 문구(desc)만. buyNotice 미지정 → QrManage 시트가 박스 미렌더(v-if).
    registerPath: '/more/qr-silver'
  }
];

// 261007 대표 지시 — 편의 QR 연락처 '공개 동의'(선택 동의, 유저 확정). 세 등록 화면(주차·반려동물·어르신)이 같은 고지를 쓴다.
//   동의하면 손님 화면에 번호·전화 버튼, 안 하면 알림만 — 서버가 공개 응답에서 번호를 뺀다(QrAssetService.publicContactPhone).
const QR_CONTACT_PUBLIC_NOTICE = {
  PARKING: { itemObj: '주차판을', caller: '주차판을 찍은 사람', purpose: '주차된 차를 빼 달라는 연락', fallback: "'차량 이동 알림'(문자·앱 알림)" },
  PETTAG: { itemObj: '목걸이 인식표를', caller: '인식표를 찍은 사람', purpose: '잃어버린 반려동물을 찾았다는 연락', fallback: "'발견 신고' 알림(문자·앱 알림)" },
  DEMENTIA: { itemObj: '안심태그를', caller: '안심태그를 찍은 사람', purpose: '길 잃은 어르신을 발견했다는 연락', fallback: "'보호자에게 알리기' 알림(문자·앱 알림)" }
};
export const qrContactPublicLines = key => {
  const n = QR_CONTACT_PUBLIC_NOTICE[key] || QR_CONTACT_PUBLIC_NOTICE.PARKING;
  return [
    '공개하는 것: 인증한 휴대폰 번호',
    `보는 사람: ${n.caller}`,
    `목적: ${n.purpose}`,
    `기간: 공개를 끄거나 ${n.itemObj} 해지할 때까지`,
    `공개하지 않아도 ${n.fallback}은 그대로 받습니다.`
  ];
};

// 261013 유저 — 번호 공개를 망설이는 등록자 안심 문구(등록 동의 단계·수정 폼). 주차판 → 반려 인식표·어르신 안심태그로 확대.
//   사실만 쓴다: 스캔 기록(tblQrScanLog, getLanding 이 종류 구분 없이 적재)은 시각 + 기기 해시(IP+UA)·UA 뿐, IP 원본은 저장하지 않으므로
//   '잡을 수 있다'·'수사기관 제공'은 쓰지 않는다. 반려·어르신 손님 화면은 번호를 적지 않고 전화 버튼만 둬서 '보입니다' 대신 '알 수 있습니다'.
//   어르신은 '옷' 금지(261007 특허 회피) → '소지품'.
const QR_CONTACT_REASSURE = {
  PARKING: { first: '번호는 차에 붙은 QR을 직접 찍은 사람에게만 보입니다. 차 유리에 번호를 써 두는 것보다 지나가는 사람 눈에 덜 띕니다.', editPlace: '마이 > 내 등록차량' }, // 261015 끄는 곳 = 앱 마이 '내 주차판'(계정 목록)
  PETTAG: { first: '번호는 인식표 QR을 직접 찍은 사람만 알 수 있습니다. 인식표에 번호를 새겨 두는 것보다 지나가는 사람 눈에 덜 띕니다.', editPlace: '반려동물 정보 수정' },
  DEMENTIA: { first: '번호는 안심태그 QR을 직접 찍은 사람만 알 수 있습니다. 소지품에 번호를 적어 두는 것보다 지나가는 사람 눈에 덜 띕니다.', editPlace: '어르신 정보 수정' }
};
export const qrContactReassureLines = key => {
  const n = QR_CONTACT_REASSURE[key] || QR_CONTACT_REASSURE.PARKING;
  return [n.first, 'QR을 찍으면 찍은 시각과 기기 기록이 남습니다.', `언제든 '${n.editPlace}'에서 공개를 끌 수 있습니다.`];
};

// 260728 카테고리 통일(대표 회의 2건) — 대분류를 간판온 앱 카테고리 기준으로 교체. 대분류 26 × 소분류 144.
//   저장값(tblQrAsset.category) = 소분류 key. 타일 템플릿·라벨 분기는 tpl(템플릿그룹) — BE QrTemplate.GROUP_OF와 1:1 계약.
//   ★ 소분류 key·tpl은 260724 체계에서 전량 불변(개통 자산 호환). 이번에 바뀐 건 group(대분류) 한 층뿐 = 무마이그레이션.
//   ★ 간판온과는 "사전만 공유"(260728 유저 확정) — 이름만 자체 키로 복제하고 테이블 조인·FK·간판온 DAO 호출은 없다(rule 17 §1 격벽).
//     따라서 label은 간판온 tblBusinessCategory.categoryName과 같은 문자열을 쓰되 저장·조인 키로는 절대 쓰지 않는다.
//     예외 1건: M_ORG label은 '교회/종교·단체'(간판온은 '교회/종교단체') — 협회·봉사·NGO 4종이 배타적 라벨에 막히는 걸 푼 유저 승인 확장.
//   대분류 key(M_*)는 저장값 아님(피커 화면 구분용). hidden:true는 신규 선택만 막고 기존 저장값 표시는 유지.
//   ⚠️ 무인매장(UNMANNED)은 260728에 대분류 leaf → 생활서비스 소분류로 강등. key·tpl 문자열은 불변(테섭 4건 개통 자산).
export const QR_CATEGORY_MAJORS = [
  { key: 'M_FOOD', icon: '🍜', label: '요식/카페', desc: '식당·카페·술집' },
  { key: 'M_RETAIL', icon: '🏪', label: '소매/판매점', desc: '편의점·마트·판매점' },
  { key: 'M_BEAUTY', icon: '💇', label: '뷰티/미용', desc: '미용실·네일·피부관리' },
  { key: 'M_MEDICAL', icon: '🏥', label: '의료/병원', desc: '병의원·치과·한의원·약국' },
  { key: 'M_SPORTS', icon: '🏆', label: '스포츠/헬스/건강', desc: '헬스·요가·필라테스·골프' },
  { key: 'M_EDU', icon: '🎓', label: '교육/학원', desc: '학원·도장·독서실' },
  { key: 'M_LIFE', icon: '🧰', label: '생활서비스', desc: '세탁·청소·수리·이사' },
  { key: 'M_INTERIOR', icon: '🛋️', label: '인테리어/디자인', desc: '인테리어·설치·디자인' },
  { key: 'M_AUTO', icon: '🚗', label: '자동차/정비', desc: '카센터·세차·렌터카·운송' },
  { key: 'M_PET', icon: '🐾', label: '반려동물', desc: '애견미용·동물병원·용품' },
  { key: 'M_HOBBY', icon: '🎳', label: '취미/여행/캠핑', desc: '노래방·PC방·오락·레저' },
  { key: 'M_LODGING', icon: '🏨', label: '숙박/펜션', desc: '호텔·모텔·펜션·게하' },
  { key: 'M_APPAREL', icon: '👕', label: '의류/잡화/안경', desc: '옷가게·잡화·안경' },
  { key: 'M_WEDDING', icon: '💒', label: '웨딩/꽃/이벤트', desc: '웨딩·꽃집·사진관·행사' },
  { key: 'M_CULTURE', icon: '🎭', label: '문화/예술/공연', desc: '공연장·전시·영화관' },
  // 261103 다이어리 할 일 #369(팀장 '공방/클래스 추가') — 공방을 문화/예술/공연에서 떼어 대분류로. 간판온에도 같은 날
  //   '공방/클래스'(120)를 넣어 양쪽이 28 대 28. 소분류는 SHOP_CRAFT 하나라 누르면 바로 확정된다(QrOnboard fnPickMajor).
  { key: 'M_CRAFT', icon: '🧶', label: '공방/클래스', desc: '공방·원데이 클래스·공예 체험' },
  { key: 'M_MEDIA', icon: '🎬', label: '미디어/콘텐츠', desc: '영상제작·1인미디어·출판' },
  { key: 'M_ADS', icon: '📣', label: '광고/기획/마케팅', desc: '광고대행·마케팅·인쇄' },
  { key: 'M_IT', icon: '💻', label: 'IT/개발', desc: 'IT개발·시스템' },
  { key: 'M_REALTY', icon: '🏠', label: '부동산', desc: '공인중개·부동산' },
  { key: 'M_LAW', icon: '⚖️', label: '법률/세무', desc: '법률·세무·노무' },
  { key: 'M_FINANCE', icon: '🏦', label: '투자/자문/금융', desc: '보험·금융·컨설팅' },
  { key: 'M_MFG', icon: '🏭', label: '제조/유통/무역', desc: '제조·유통·무역' },
  { key: 'M_BUILD', icon: '🏗️', label: '건설/건축', desc: '종합건설·설비·창호' },
  // 260810 대표 지시: 협회·봉사단체·NGO를 '기타'로 빼고 여기엔 교회만 남긴다.
  //   라벨도 '교회/종교·단체' → '교회'로 좁힌다. 예전엔 단체 사용자가 배타적 라벨에 안 눌릴까 봐
  //   일부러 넓게 적어뒀는데, 이제 그들이 갈 방(기타)이 생겨서 그 이유가 없어졌다.
  { key: 'M_ORG', icon: '⛪', label: '교회', desc: '교회·성당 등 예배 공간' },
  // 260807 정리(18) 부장 표 78번 — 무인매장을 **대분류로 승격**(260728에 생활서비스 소분류로 강등됐던 것을 되돌림).
  //   간판온에도 같은 날 '무인매장'(119)을 신설해 양쪽이 27 대 27로 맞는다.
  { key: 'M_UNMAN', icon: '🤖', label: '무인매장', desc: '무인카페·무인점포·셀프매장' },
  { key: 'M_FRANCHISE', icon: '🚀', label: '창업/프랜차이즈', desc: '프랜차이즈 본사·창업', hidden: true },
  // 260810: hidden 해제 — 협회·봉사단체·NGO가 여기로 들어오면서 실제로 고를 방이 됐다.
  { key: 'M_ETC', icon: '🏷️', label: '기타', desc: '협회·단체 등 위에 없는 업종' }
];
export const QR_CATEGORY_LIST = [
  // 1. 요식/카페
  { key: 'EAT_KOREAN', icon: '🍚', label: '한식', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_CHINESE', icon: '🥟', label: '중식', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_JAPANESE', icon: '🍣', label: '일식', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_WESTERN', icon: '🍝', label: '양식', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_SNACK', icon: '🍢', label: '분식', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_CHICKEN', icon: '🍗', label: '치킨', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_PIZZA', icon: '🍕', label: '피자', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_FASTFOOD', icon: '🍔', label: '패스트푸드', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_MEAT', icon: '🥩', label: '고기집', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_SEAFOOD', icon: '🦐', label: '해산물', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_BUFFET', icon: '🍽️', label: '뷔페', group: 'M_FOOD', tpl: 'FOOD' },
  { key: 'EAT_CAFE', icon: '☕', label: '카페·디저트', group: 'M_FOOD', tpl: 'CAFE' },
  { key: 'EAT_BAKERY', icon: '🥐', label: '베이커리', group: 'M_FOOD', tpl: 'CAFE' },
  { key: 'EAT_RICECAKE', icon: '🍡', label: '떡집', group: 'M_FOOD', tpl: 'CAFE' },
  { key: 'EAT_BAR', icon: '🍶', label: '일반술집', group: 'M_FOOD', tpl: 'PUB' },
  { key: 'EAT_HOF', icon: '🍺', label: '호프', group: 'M_FOOD', tpl: 'PUB' },
  { key: 'EAT_WINEBAR', icon: '🍷', label: '와인바', group: 'M_FOOD', tpl: 'PUB' },
  { key: 'EAT_IZAKAYA', icon: '🏮', label: '이자카야', group: 'M_FOOD', tpl: 'PUB' },
  { key: 'EAT_BISTROPUB', icon: '🍲', label: '요리주점', group: 'M_FOOD', tpl: 'PUB' },
  { key: 'EAT_BOOKCAFE', icon: '📖', label: '북카페', group: 'M_FOOD', tpl: 'CAFE' },
  { key: 'EAT_ETC', icon: '🏷️', label: '기타', group: 'M_FOOD', tpl: 'FOOD' },
  // 2. 소매/판매점
  { key: 'SHOP_CONV', icon: '🏪', label: '편의점', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_MART', icon: '🛒', label: '마트', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_FOOD', icon: '🥬', label: '식품전문점', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_MOBILE', icon: '📱', label: '휴대폰', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_ELEC', icon: '📺', label: '가전', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_STATIONERY', icon: '✏️', label: '문구', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_BOOK', icon: '📚', label: '서점', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_FURNITURE', icon: '🛋️', label: '가구', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_KITCHEN', icon: '🍳', label: '주방용품', group: 'M_RETAIL', tpl: 'STORE' },
  { key: 'SHOP_ETC', icon: '🏷️', label: '기타', group: 'M_RETAIL', tpl: 'STORE' },
  // 3. 뷰티/미용
  { key: 'CARE_HAIR', icon: '💇', label: '이·미용실', group: 'M_BEAUTY', tpl: 'BEAUTY' },
  { key: 'CARE_BARBER', icon: '💈', label: '바버샵', group: 'M_BEAUTY', tpl: 'BEAUTY' },
  { key: 'CARE_NAIL', icon: '💅', label: '네일', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_SKIN', icon: '🧖', label: '피부관리', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_WAXING', icon: '✨', label: '왁싱', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_MASSAGE', icon: '💆', label: '마사지·스파', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_LASH', icon: '👁️', label: '속눈썹', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_MAKEUP', icon: '💄', label: '메이크업', group: 'M_BEAUTY', tpl: 'BEAUTY' },
  { key: 'CARE_TANNING', icon: '☀️', label: '태닝', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_DIET', icon: '⚖️', label: '다이어트', group: 'M_BEAUTY', tpl: 'SKIN' },
  { key: 'CARE_ETC', icon: '🏷️', label: '기타', group: 'M_BEAUTY', tpl: 'BEAUTY' },
  { key: 'SHOP_COSMETIC', icon: '💄', label: '화장품', group: 'M_BEAUTY', tpl: 'STORE' },
  // 4. 의료/병원
  { key: 'CARE_CLINIC', icon: '🏥', label: '병의원', group: 'M_MEDICAL', tpl: 'CLINIC' },
  { key: 'CARE_DENTAL', icon: '🦷', label: '치과', group: 'M_MEDICAL', tpl: 'CLINIC' },
  { key: 'CARE_PLASTIC', icon: '💉', label: '성형외과', group: 'M_MEDICAL', tpl: 'CLINIC' },
  { key: 'CARE_DERMA', icon: '🧴', label: '피부과', group: 'M_MEDICAL', tpl: 'CLINIC' },
  { key: 'CARE_HANMED', icon: '🌿', label: '한의원', group: 'M_MEDICAL', tpl: 'CLINIC' },
  { key: 'CARE_PHARMACY', icon: '💊', label: '약국', group: 'M_MEDICAL', tpl: 'PHARMACY' },
  // 5. 스포츠/헬스/건강
  { key: 'EAT_BILLIARD', icon: '🎱', label: '당구장', group: 'M_SPORTS', tpl: 'PLAY' },
  { key: 'EAT_SCREENGOLF', icon: '⛳', label: '스크린골프', group: 'M_SPORTS', tpl: 'PLAY' },
  { key: 'CARE_GYM', icon: '💪', label: '헬스', group: 'M_SPORTS', tpl: 'GYM' },
  { key: 'CARE_PT', icon: '💪', label: 'PT', group: 'M_SPORTS', tpl: 'GYM' },
  { key: 'CARE_YOGA', icon: '🧘', label: '요가', group: 'M_SPORTS', tpl: 'GYM' },
  { key: 'CARE_PILATES', icon: '🤸', label: '필라테스', group: 'M_SPORTS', tpl: 'GYM' },
  { key: 'CARE_GOLF', icon: '⛳', label: '골프연습장', group: 'M_SPORTS', tpl: 'GYM' },
  { key: 'CARE_FIGHT', icon: '🥊', label: '격투기', group: 'M_SPORTS', tpl: 'GYM' },
  { key: 'EDU_BOXING', icon: '🥊', label: '복싱', group: 'M_SPORTS', tpl: 'DOJANG' },
  // 6. 교육/학원
  { key: 'EDU_ENTRANCE', icon: '🎯', label: '입시', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_SUPPLEMENT', icon: '📝', label: '보습', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_CORE', icon: '✏️', label: '국·영·수', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_SCIENCE', icon: '🔬', label: '과학', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_KIDS', icon: '🧒', label: '유아교육', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_CONSULT', icon: '🧭', label: '교육컨설팅', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_CAREER', icon: '📜', label: '취업·자격증', group: 'M_EDU', tpl: 'ACADEMY' },
  { key: 'EDU_MUSIC', icon: '🎹', label: '음악', group: 'M_EDU', tpl: 'ACADEMY_HOBBY' },
  { key: 'EDU_ART', icon: '🎨', label: '미술', group: 'M_EDU', tpl: 'ACADEMY_HOBBY' },
  { key: 'EDU_DANCE', icon: '💃', label: '무용·발레', group: 'M_EDU', tpl: 'ACADEMY_HOBBY' },
  { key: 'EDU_TAEKWONDO', icon: '🥋', label: '태권도', group: 'M_EDU', tpl: 'DOJANG' },
  { key: 'EDU_KENDO', icon: '⚔️', label: '검도', group: 'M_EDU', tpl: 'DOJANG' },
  { key: 'EDU_JUDO', icon: '🤼', label: '유도', group: 'M_EDU', tpl: 'DOJANG' },
  { key: 'EDU_READING', icon: '📚', label: '독서실', group: 'M_EDU', tpl: 'UNMANNED' },
  { key: 'EDU_STUDYCAFE', icon: '💺', label: '스터디카페', group: 'M_EDU', tpl: 'UNMANNED' },
  { key: 'EDU_ETC', icon: '🏷️', label: '기타', group: 'M_EDU', tpl: 'ACADEMY' },
  // 7. 생활서비스
  { key: 'LIFE_LAUNDRY', icon: '🧺', label: '빨래방', group: 'M_LIFE', tpl: 'UNMANNED' },
  { key: 'LIFE_PEST', icon: '🐜', label: '방역', group: 'M_LIFE', tpl: 'MOBILE' },
  { key: 'LIFE_MOVING', icon: '🚚', label: '이사', group: 'M_LIFE', tpl: 'MOBILE' },
  { key: 'LIFE_CLEANING', icon: '🧹', label: '청소', group: 'M_LIFE', tpl: 'MOBILE' },
  { key: 'LIFE_INSTALL', icon: '🔧', label: '설치·수리', group: 'M_LIFE', tpl: 'REPAIR' },
  { key: 'LIFE_ETC', icon: '🏷️', label: '기타', group: 'M_LIFE', tpl: 'REPAIR' },
  // 260807 정리(18) — 대분류 승격에 따라 생활서비스 → 무인매장 소속으로 이동.
  //   ⚠️key·tpl 문자열은 **불변**이다(개통 자산의 category 저장값이라 바꾸면 기존 현판이 미아가 된다).
  //   바뀌는 건 group 하나뿐 — 저장값 무변경·마이그레이션 0.
  { key: 'UNMANNED', icon: '🤖', label: '무인매장', group: 'M_UNMAN', tpl: 'UNMANNED' },
  // 8. 인테리어/디자인
  { key: 'LIFE_INTERIOR', icon: '🛋️', label: '인테리어', group: 'M_INTERIOR', tpl: 'REPAIR' },
  { key: 'PRO_DESIGN', icon: '🎨', label: '디자인', group: 'M_INTERIOR', tpl: 'OFFICE' },
  // 9. 자동차/정비
  { key: 'AUTO_REPAIR', icon: '🔧', label: '카센터', group: 'M_AUTO', tpl: 'CAR' },
  { key: 'AUTO_TIRE', icon: '⚙️', label: '타이어', group: 'M_AUTO', tpl: 'CAR' },
  { key: 'AUTO_WASH', icon: '🚿', label: '세차', group: 'M_AUTO', tpl: 'CAR' },
  { key: 'AUTO_RENT', icon: '🚗', label: '렌터카', group: 'M_AUTO', tpl: 'CAR' },
  { key: 'AUTO_TRANSPORT', icon: '🚕', label: '운수', group: 'M_AUTO', tpl: 'MOBILE' },
  { key: 'AUTO_COURIER', icon: '🚚', label: '운송', group: 'M_AUTO', tpl: 'MOBILE' },
  { key: 'AUTO_LOGISTICS', icon: '📦', label: '물류센터', group: 'M_AUTO', tpl: 'OFFICE' },
  { key: 'AUTO_ETC', icon: '🏷️', label: '기타', group: 'M_AUTO', tpl: 'CAR' },
  // 10. 반려동물
  { key: 'LIFE_PETGROOM', icon: '🐩', label: '애견미용', group: 'M_PET', tpl: 'PET' },
  { key: 'LIFE_PETCAFE', icon: '🐶', label: '애견카페', group: 'M_PET', tpl: 'PET' },
  { key: 'LIFE_PETHOTEL', icon: '🏡', label: '애견유치원·호텔', group: 'M_PET', tpl: 'PET' },
  { key: 'LIFE_PETSHOP', icon: '🦴', label: '반려동물용품', group: 'M_PET', tpl: 'STORE' },
  { key: 'LIFE_VET', icon: '🐾', label: '동물병원', group: 'M_PET', tpl: 'CLINIC' },
  // 11. 취미/여행/캠핑
  { key: 'EAT_KARAOKE', icon: '🎤', label: '노래연습장', group: 'M_HOBBY', tpl: 'PLAY' },
  { key: 'EAT_PCROOM', icon: '🖥️', label: 'PC방', group: 'M_HOBBY', tpl: 'PLAY' },
  { key: 'EAT_BOARDGAME', icon: '🎲', label: '보드게임', group: 'M_HOBBY', tpl: 'PLAY' },
  { key: 'EAT_KIDSCAFE', icon: '🧸', label: '키즈카페', group: 'M_HOBBY', tpl: 'PLAY' },
  { key: 'EAT_ESCAPE', icon: '🗝️', label: '방탈출', group: 'M_HOBBY', tpl: 'PLAY' },
  { key: 'STAY_LEISURE', icon: '🎢', label: '체험·레저', group: 'M_HOBBY', tpl: 'CULTURE' },
  // 12. 숙박/펜션
  { key: 'STAY_HOTEL', icon: '🏨', label: '호텔', group: 'M_LODGING', tpl: 'LODGING' },
  { key: 'STAY_MOTEL', icon: '🛏️', label: '모텔', group: 'M_LODGING', tpl: 'LODGING' },
  { key: 'STAY_GUESTHOUSE', icon: '🛌', label: '게스트하우스', group: 'M_LODGING', tpl: 'LODGING' },
  { key: 'STAY_PENSION', icon: '🏡', label: '펜션', group: 'M_LODGING', tpl: 'LODGING' },
  // 13. 의류/잡화/안경
  { key: 'SHOP_FASHION', icon: '👕', label: '의류·잡화', group: 'M_APPAREL', tpl: 'STORE' },
  { key: 'SHOP_OPTIC', icon: '👓', label: '안경', group: 'M_APPAREL', tpl: 'STORE' },
  { key: 'SHOP_GOODS', icon: '🎁', label: '소품', group: 'M_APPAREL', tpl: 'STORE' },
  // 14. 웨딩/꽃/이벤트
  { key: 'SHOP_FLOWER', icon: '💐', label: '꽃', group: 'M_WEDDING', tpl: 'STORE' },
  { key: 'STAY_WEDDING', icon: '💒', label: '웨딩', group: 'M_WEDDING', tpl: 'STUDIO' },
  { key: 'STAY_PHOTO', icon: '📸', label: '사진·스튜디오', group: 'M_WEDDING', tpl: 'STUDIO' },
  { key: 'STAY_PARTY', icon: '🎉', label: '이벤트·파티', group: 'M_WEDDING', tpl: 'STUDIO' },
  { key: 'STAY_RENTSPACE', icon: '🔑', label: '공간대여', group: 'M_WEDDING', tpl: 'STUDIO' },
  { key: 'STAY_ETC', icon: '🏷️', label: '기타', group: 'M_WEDDING', tpl: 'STUDIO' },
  // 15. 문화/예술/공연
  // 261103 공방/클래스 대분류 신설 — 소속(group)만 M_CULTURE → M_CRAFT. key·tpl 은 개통 자산 저장값이라 그대로(BE MAJOR_OF 와 1:1).
  { key: 'SHOP_CRAFT', icon: '🧶', label: '공방', group: 'M_CRAFT', tpl: 'STUDIO' },
  { key: 'STAY_THEATER', icon: '🎭', label: '공연장', group: 'M_CULTURE', tpl: 'CULTURE' },
  { key: 'STAY_EXHIBIT', icon: '🖼️', label: '전시관', group: 'M_CULTURE', tpl: 'CULTURE' },
  { key: 'STAY_CINEMA', icon: '🎬', label: '영화관', group: 'M_CULTURE', tpl: 'CULTURE' },
  // 16. 미디어/콘텐츠
  { key: 'MEDIA_VIDEO', icon: '🎬', label: '영상제작', group: 'M_MEDIA', tpl: 'OFFICE' },
  { key: 'MEDIA_CREATOR', icon: '📹', label: '유튜브·1인미디어', group: 'M_MEDIA', tpl: 'OFFICE' },
  { key: 'MEDIA_PRESS', icon: '📰', label: '신문·방송·출판', group: 'M_MEDIA', tpl: 'OFFICE' },
  // 17. 광고/기획/마케팅
  { key: 'PRO_AD', icon: '📣', label: '광고·마케팅', group: 'M_ADS', tpl: 'OFFICE' },
  { key: 'PRO_PRINT', icon: '🖨️', label: '인쇄·출판', group: 'M_ADS', tpl: 'OFFICE' },
  // 18. IT/개발
  { key: 'PRO_IT', icon: '💻', label: 'IT개발', group: 'M_IT', tpl: 'OFFICE' },
  // 19. 부동산
  { key: 'PRO_REALTY', icon: '🏠', label: '부동산', group: 'M_REALTY', tpl: 'REALTY' },
  // 20. 법률/세무
  // 260903 유저 "세무회계랑 법률을 따로 구분하지마 그냥 통합시켜" — 전문직 사무실은 한 라인이다.
  //   PRO_TAX·PRO_LABOR는 피커에서 뺐다(아래 LEGACY로 이관). 화면·타일·어휘는 어차피 대분류(M_LAW)
  //   축이라 셋이 이미 동일했고, 간판온도 businessCategoryNo 101 '법률/세무' 하나로 통합돼 있다.
  //   제거 근거 = ORG_ETC 선례와 같은 절차(소분류엔 hidden이 없다 → 운영 tblQrAsset 사용 0건 실조회 후 제거).
  { key: 'PRO_LAW', icon: '⚖️', label: '법률·세무·노무', group: 'M_LAW', tpl: 'OFFICE' },
  // 21. 투자/자문/금융
  { key: 'PRO_FINANCE', icon: '🏦', label: '보험·금융', group: 'M_FINANCE', tpl: 'OFFICE' },
  { key: 'PRO_CONSULT', icon: '💼', label: '컨설팅', group: 'M_FINANCE', tpl: 'OFFICE' },
  // 22. 제조/유통/무역
  { key: 'SHOP_MFG', icon: '🏭', label: '제조', group: 'M_MFG', tpl: 'OFFICE' },
  { key: 'SHOP_DIST', icon: '📦', label: '유통', group: 'M_MFG', tpl: 'OFFICE' },
  { key: 'SHOP_TRADE', icon: '🚢', label: '무역', group: 'M_MFG', tpl: 'OFFICE' },
  // 23. 건설/건축
  { key: 'BUILD_GENERAL', icon: '🏗️', label: '종합건설·시공', group: 'M_BUILD', tpl: 'OFFICE' },
  { key: 'BUILD_EQUIP', icon: '🚜', label: '중장비·석재', group: 'M_BUILD', tpl: 'OFFICE' },
  { key: 'BUILD_FACILITY', icon: '🔌', label: '설비·전기', group: 'M_BUILD', tpl: 'REPAIR' },
  { key: 'BUILD_WINDOW', icon: '🪟', label: '창호·샷시', group: 'M_BUILD', tpl: 'REPAIR' },
  // 24. 교회 — 260810 대표 지시: '교회'를 눌렀는데 협회·봉사단체·NGO가 같이 나오는 게 이상하다.
  //   → 이 대분류엔 교회만 남기고 단체 3종은 '기타'로 옮겼다(아래 26번).
  //   tpl은 그대로 둔다 — 단체는 계속 GROUP 템플릿을 받는다(대분류만 바뀐 것).
  { key: 'ORG_CHURCH', icon: '⛪', label: '교회', group: 'M_ORG', tpl: 'CHURCH' },
  // 25. 창업/프랜차이즈 — 소분류 없음(피커 hidden)
  // 26. 기타 — 260810: hidden 해제. 위 단체 3종이 여기로 온다.
  //   ORG_ETC('기타')는 삭제했다 — 같은 방에 PRO_ETC('기타')가 이미 있어 목록에 '기타'가 두 줄로 뜬다.
  //   소분류엔 hidden 개념이 없어 숨길 수도 없다. 운영 tblQrAsset 사용 0건 실조회 후 제거.
  //   ⚠️ BE(QrTemplate.resolveMajor)에는 레거시 저장값 해석용으로 ORG_ETC를 남겨 뒀다.
  { key: 'ORG_ASSOC', icon: '🤝', label: '협회', group: 'M_ETC', tpl: 'GROUP' },
  { key: 'ORG_VOLUNTEER', icon: '🙌', label: '봉사단체', group: 'M_ETC', tpl: 'GROUP' },
  { key: 'ORG_NGO', icon: '🌍', label: 'NGO', group: 'M_ETC', tpl: 'GROUP' },
  { key: 'PRO_ETC', icon: '🏷️', label: '기타', group: 'M_ETC', tpl: 'OFFICE' }
];

// 레거시 23키(구 flat 체계) — 기개통 자산이 물고 있어 삭제·개명 금지. 피커엔 비노출, 라벨·tpl 리졸브만.
//   260728: UNMANNED는 QR_CATEGORY_LIST에도 소분류로 들어갔다(생활서비스). qrCategoryMeta가 LIST를 먼저 보므로
//   그쪽이 이기고, 여기 항목은 tpl identity 폴백용으로만 남는다 — 중복이 아니라 의도된 이중 등재.
//   SOLO(1인 기업)·ETC(전역 기타)는 260724 대표 taxonomy에서 제외 확정 — 신규 개통 불가·기존 자산 표시만.
export const QR_CATEGORY_LEGACY = {
  FOOD: { icon: '🍜', label: '식당' }, CAFE: { icon: '☕', label: '카페·베이커리' }, PUB: { icon: '🍺', label: '주점·호프' },
  BEAUTY: { icon: '💇', label: '헤어·미용실' }, SKIN: { icon: '💅', label: '네일·피부·속눈썹' },
  CLINIC: { icon: '🏥', label: '병원·의원' }, PHARMACY: { icon: '💊', label: '약국' }, GYM: { icon: '🏋️', label: '헬스·요가·필라테스' },
  ACADEMY: { icon: '📚', label: '입시·보습·어학 학원' }, ACADEMY_HOBBY: { icon: '🎨', label: '취미·예체능 학원' }, DOJANG: { icon: '🥋', label: '태권도·체육관' },
  STORE: { icon: '🛍️', label: '판매점·소매점' }, UNMANNED: { icon: '🤖', label: '무인매장' }, STUDIO: { icon: '📸', label: '스튜디오·공방' },
  PET: { icon: '🐾', label: '반려동물' }, REALTY: { icon: '🏠', label: '부동산' }, REPAIR: { icon: '🔧', label: '수리·세탁' },
  OFFICE: { icon: '🏢', label: '사무실·회사' }, SOLO: { icon: '👤', label: '1인 기업·프리랜서' }, MOBILE: { icon: '🚐', label: '출장·차량' },
  CHURCH: { icon: '⛪', label: '교회' }, GROUP: { icon: '🤝', label: '단체·모임·협회' }, ETC: { icon: '🏷️', label: '기타' },
  // 260903 전문직 통합 — PRO_LAW로 합치며 피커에서 뺀 두 키. 기개통 자산이 물고 있어 리졸브는 살려 둔다.
  //   ⚠️tpl·group을 명시하는 이유: 스프레드가 { tpl: key } 를 덮어야 한다. 안 그러면 tpl이 'PRO_TAX'가 되고
  //     group이 undefined라 사무실 어휘·상담폼 분기(M_LAW 축)가 통째로 빠진다.
  PRO_TAX: { icon: '🧾', label: '세무·회계', tpl: 'OFFICE', group: 'M_LAW' },
  PRO_LABOR: { icon: '🤝', label: '노무', tpl: 'OFFICE', group: 'M_LAW' },
  // 신규 템플릿그룹 4종 — 저장값으론 안 쓰이지만 tpl 라벨 폴백용(레거시 키 tpl=자기 자신 관례와 동일)
  PLAY: { icon: '🎳', label: '놀이·오락' }, CAR: { icon: '🚗', label: '차량 정비·서비스' },
  LODGING: { icon: '🏨', label: '숙박' }, CULTURE: { icon: '🎭', label: '문화·관람' }
};
// ★ 카테고리 메타·템플릿그룹 단일 진원 리졸버 — category 키를 소비하는 모든 곳은 이 둘을 거친다.
export const qrCategoryMeta = key =>
  QR_CATEGORY_LIST.find(c => c.key === key) ||
  (QR_CATEGORY_LEGACY[key] ? { key, tpl: key, ...QR_CATEGORY_LEGACY[key] } : null);
export const qrTplOf = key => (qrCategoryMeta(key) || {}).tpl || key || '';
export const qrCategoryLabel = key => (qrCategoryMeta(key) || {}).label || key || '';
export const qrMajorOf = key => QR_CATEGORY_MAJORS.find(m => m.key === key) || null;
// 피커(온보딩·업종변경)에 실제로 그릴 대분류 — hidden(신규 선택 차단) + 소분류 0개(빈 화면 방지) 제외.
//   260728: 창업/프랜차이즈=앱 실매장 0건이라 소분류 미시딩, 기타=PRO_ETC 하나뿐이라 legacy-only.
//   저장값·라벨 리졸브는 위 qrCategoryMeta가 계속 커버하므로 기존 자산 표시는 안 깨진다.
export const qrVisibleMajors = () => QR_CATEGORY_MAJORS.filter(
  m => !m.hidden && QR_CATEGORY_LIST.some(c => c.group === m.key));
export const qrSubsOf = majorKey => QR_CATEGORY_LIST.filter(c => c.group === majorKey);
// 260812 개통 프리셋 축소 — 용도가 정해진 QR(메뉴판 등)은 그 용도가 성립하는 업종만 고르게 한다.
//   allowed = BE가 내려준 허용 소분류 키 배열(QrLandingResponse.allowedCategories / 보증서 allowedCategories).
//   ⚠️판정은 BE(QrTemplate.categoriesSupporting) 한 곳이고 FE는 결과만 거른다 — FE가 platform→업종을 다시 계산하면
//     템플릿을 중복 보유하게 되고(FE/BE 단일 소스 계약) 한쪽만 고쳐져 갈린다.
//   ⚠️빈 배열·누락 = "좁힐 근거 없음"이지 "해당 업종 없음"이 아니다 → 전체를 그대로 돌려준다.
//     전부 걸러지는 경우(레거시 자산 등)도 전체로 폴백한다. 안 그러면 업종을 못 고르는 막다른 화면이 된다.
export const qrMajorsScoped = allowed => {
  const majors = qrVisibleMajors();
  if (!allowed || !allowed.length) return majors;
  const set = new Set(allowed);
  const scoped = majors.filter(m => QR_CATEGORY_LIST.some(c => c.group === m.key && set.has(c.key)));
  return scoped.length ? scoped : majors;
};
export const qrSubsScoped = (majorKey, allowed) => {
  const subs = qrSubsOf(majorKey);
  if (!allowed || !allowed.length) return subs;
  const set = new Set(allowed);
  const scoped = subs.filter(c => set.has(c.key));
  return scoped.length ? scoped : subs;
};
// 260730 소분류 저장값 → 대분류 key (업종별 정책 조회용). 레거시·미등록 키는 null
export const qrGroupKeyOf = category => (QR_CATEGORY_LIST.find(c => c.key === category) || {}).group || null;

export const QR_PLATFORM_META = {
  // 공통
  PHONE: { icon: '📞', label: '전화 주문·예약' }, // 260722 시트5 #17 대표컨펌 — 전 업종 '전화 주문·예약'으로 통일(업종 오버라이드 제거)
  NOTICE: { icon: '📌', label: '한줄공지' },
  HOURS: { icon: '🕐', label: '영업시간' },
  BIZTALK: { icon: '💬', label: '문의 남기기' },
  GANPANON: { icon: '🟢', label: '간판ON' },
  ORDER_HUB: { icon: '🛵', label: '주문하기' }, // Wave1 FE 가상 타일 — 배달·주문 링크 묶음 큐브(BE 행 없음)
  SIGNUP: { icon: '📲', label: '회원가입' }, // 260923 대표 — FE 가상 타일(BE 행 없음). 비로그인 손님에게만, 탭=앱 설치(QrLanding fnCube)
  MAP: { icon: '🗺️', label: '오시는 길', guide: '주소만 적으면 지도 링크가 자동으로 — 또는 지도 앱에서 가게 검색 → 공유 → 링크 복사' },
  INSTAGRAM: { icon: '📷', label: '인스타그램', guide: '@아이디를 그대로 적어주세요 (예: @cafe.jeju) — 또는 앱에서 내 프로필 → 프로필 공유 → 링크 복사' },
  NAVER_PLACE: { icon: '🧭', label: '네이버 플레이스', guide: '네이버 지도에서 내 가게 검색 → 공유 → URL 복사' },
  // 260818 시트21 운영#3 — 구글 맵. BE QrTemplate COMMON(defaultOn=false)과 1:1 계약(rules/17 §4).
  // 260818 아이콘 재선정(코덱스) — 📍는 WORK_SITE(작업 현장)와 완전 중복이었다.
  //   🔍는 후보였지만 반려: 같은 관리 화면 지도 타일 편집기의 '주소 검색하기' 버튼이 이미 쓴다(QrManage).
  //   🛰️ = 접힌 지도 🗺️·원형 나침반 🧭·물방울 핀 📍과 실루엣이 달라 흑백에서도 구분된다.
  GOOGLE_MAP: { icon: '🛰️', label: '구글 맵', guide: 'Google 지도에서 내 가게 검색 → 공유 → 링크 복사' },
  HOMEPAGE: { icon: '🌐', label: '홈페이지', guide: '주소창의 홈페이지 주소를 복사해 붙여넣기 (앞의 https:// 는 지우고 붙여넣어도 돼요)' },
  KAKAO_CH: { icon: '💛', label: '카카오 채널', guide: '카카오톡 채널 관리자센터 → 채널 정보 → 채널 URL 복사' },
  WIFI: { icon: '📶', label: '와이파이' },
  TOILET: { icon: '🚻', label: '화장실' }, // 260721 화장실 안내 — 와이파이에서 분리(위치·비번·메모)
  YOUTUBE: { icon: '▶', label: '유튜브', brand: '#FF0000', mono: true, guide: '유튜브 앱 → 내 채널 → 공유 → 링크 복사' },
  FACEBOOK: { icon: 'f', label: '페이스북', brand: '#1877F2', mono: true, guide: '페이스북 페이지 → 공유 → 링크 복사' },
  BLOG: { icon: 'b', label: '블로그', brand: '#2DB400', mono: true, guide: '네이버 블로그 앱 → 내 블로그 → 공유 → URL 복사' },
  SHOP: { icon: '🛒', label: '쇼핑몰', guide: '스마트스토어·쇼핑몰 대표 주소 복사 (예: smartstore.naver.com/상점명)' },
  PARKING: { icon: '🅿️', label: '주차 안내' },
  // 260708 ③ 명함다운 — 여러 명 등록, 소비자 다운로드는 간판온 로그인 경유(vCard)
  VCARD: { icon: '📇', label: '명함 받기' },
  GALLERY: { icon: '🖼️', label: '사진' },
  // 260814 매장 Q&A — 전 업종 공통. 전용 PNG(tiles/faq.png) 미제작이라 이모지 폴백으로 뜬다(❓ — 💬는 BIZTALK과 중복).
  FAQ: { icon: '❓', label: '매장 Q&A' },
  SAVE_BIZ: { icon: '🔖', label: '기업 저장' },
  ONLINE_MEMORIAL: { icon: '🕯️', label: '온라인 추모관' },
  // 식당·카페
  MENU: { icon: '🍽️', label: '메뉴판' },
  NAVER_ORDER: { icon: 'N', label: '네이버 주문', brand: '#03C75A', mono: true, guide: '네이버 플레이스에서 주문 주소를 복사해서 넣어주세요 (스마트플레이스 사장님 앱 → 주문 → 링크 복사)' }, // 260722 시트5 #7 대표 문구
  KAKAO_ORDER: { icon: '🛒', label: '카카오 주문', guide: '카카오톡 채널 관리자센터 → 비즈니스 도구 → 주문 링크 복사' }, // 260720 아이콘 💬→🛒 (BIZTALK 💬 중복 해소)
  BAEMIN: { icon: '🛵', label: '배달의민족', brand: '#2AC1BC', mono: true, guide: '배민 사장님광장(셀프서비스) → 가게 홍보 → 가게 링크(baemin.me) 복사' },
  YOGIYO: { icon: '🛵', label: '요기요', guide: '요기요 사장님사이트 → 내 가게 → 가게 링크(주소) 복사' },
  COUPANG_EATS: { icon: '🛵', label: '쿠팡이츠', guide: '쿠팡이츠 사장님 사이트 → 내 매장 → 매장 링크 복사' },
  TODAY_SPECIAL: { icon: '⭐', label: '오늘의 메뉴·할인' },
  TABLE_ORDER: { icon: '🧾', label: '테이블 주문' },
  DELIVERY: { icon: '🛵', label: '기타 배달', guide: '땡겨요 등 다른 배달 앱의 내 매장(사업장) 링크를 넣어주세요' },
  WAITING: { icon: '⏳', label: '웨이팅 등록' },
  GROUP_INQUIRY: { icon: '👥', label: '단체·예약 문의' },
  ORIGIN_LABEL: { icon: '🏷️', label: '원산지 표시' },
  // 미용·뷰티
  PRICE_MENU: { icon: '💈', label: '가격표' }, // 260722 시트5 #12/#25 — 미용건강·매장/시설 공용, 먹거리 '메뉴판'은 별개 platform(MENU)
  BUSY_MESSAGE: { icon: '🔕', label: '시술중 안내' },
  NAVER_BOOKING: { icon: '📅', label: '네이버 예약', guide: '네이버 예약 파트너센터 → 내 예약 페이지 URL을 복사해서 넣으세요' },
  STAFF_INTRO: { icon: '🙋', label: '스태프 소개' },
  BEFORE_AFTER: { icon: '✨', label: '시술 전후 사진' },
  FIRST_EVENT: { icon: '🎁', label: '첫 방문 이벤트' },
  // 260814 시트20 — 기본(소비자 업종)은 '할인행사/이벤트'. 기업형·무인매장은 QR_LABEL_BY_MAJOR가 덮는다.
  EVENT_INFO: { icon: '🎉', label: '할인행사/이벤트' },
  GAME: { icon: '🎡', label: '게임\n(룰렛·사다리)' }, // 260901 유저 — 큐브에서 두 줄로(qrl__grid-label pre-line)
  // 병원·의원
  CLINIC_HOURS: { icon: '🕐', label: '진료시간·휴진' },
  DEPARTMENTS: { icon: '🩺', label: '진료 과목' },
  RESERVATION: { icon: '📅', label: '접수·예약', guide: '사용 중인 예약 서비스(네이버 예약·똑닥 등)의 예약 페이지 링크 복사' },
  NON_COVERED: { icon: '📋', label: '비급여 안내' },
  FLOOR_PARKING: { icon: '🅿️', label: '층·주차 안내' },
  // 교육(학원·도장·헬스) — 260709 세분화로 GYM·DOJANG·ACADEMY_HOBBY가 공유
  TIMETABLE: { icon: '🗓️', label: '시간표' },
  TUITION: { icon: '💳', label: '수강료·이용권' },
  CONSULT: { icon: '📝', label: '상담 신청' },
  SHUTTLE: { icon: '🚌', label: '셔틀버스' }, // 260721 '교통편'→'셔틀버스' — MAP(오시는 길)과 헷갈린다는 대표 지적. 실체=학원·도장 차량 운행 안내
  TRIAL: { icon: '🎫', label: '무료 체험' },
  RESULTS: { icon: '🏆', label: '합격·수상 실적' },
  // 260825 학원 확장 — 신규 3종(kind: CLASSES·MSG·EVENTS). PNG 미제작 이모지 폴백(FAQ 관례)
  CURRICULUM: { icon: '📚', label: '커리큘럼' },
  LEVEL_TEST: { icon: '🎯', label: '레벨테스트 신청' },
  ACADEMY_EVENT: { icon: '📆', label: '학원 일정' },
  // 사무실·회사
  COMPANY_INTRO: { icon: '🏢', label: '회사 소개' },
  COMPANY_NEWS: { icon: '📰', label: '사내 소식' },
  CAR_REG: { icon: '🚗', label: '방문차량 등록' },
  DOORBELL: { icon: '🔔', label: '벨 누르기' },
  ATTENDANCE: { icon: '⏱️', label: '출퇴근' },
  // 260804 긴급 공지 — 전 업종 공통(기본 OFF, 토핑 그룹은 '자주 쓰는 기능').
  //   ⚠️더보기 가나다 목록에서 EMERGENCY(🚨 긴급 연락처)와 나란히 뜬다. 헷갈리면 안 되는 두 타일이다:
  //   이쪽은 '오늘 이런 일이 있다'(내용 + 노출 종료일), 저쪽은 '급하면 여기로 거세요'(상시 번호).
  // 260818 아이콘 재선정(코덱스) — 📛는 유니코드상 'name badge'(이름표)라 경고로 안 읽혔다.
  //   ⚠️는 🚨EMERGENCY·📢RECRUIT·📌NOTICE·🔔DOORBELL·🔕BUSY_MESSAGE와 나란히 떠도 구분된다.
  URGENT_NOTICE: { icon: '⚠️', label: '긴급 공지' },
  CONTACTS: { icon: '📇', label: '담당자 안내' },
  CATALOG: { icon: '📁', label: '카탈로그', guide: '카탈로그 PDF나 소개 페이지 링크 붙여넣기' },
  QUOTE: { icon: '🧮', label: '견적 문의' },
  RECRUIT: { icon: '📢', label: '구인 중' },
  COURIER_NOTE: { icon: '📦', label: '택배기사님 보세요' },
  // 무인 매장
  HOW_TO_USE: { icon: '📖', label: '이용 방법' },
  EMERGENCY: { icon: '🚨', label: '긴급 연락처' },
  REPORT_ISSUE: { icon: '🛠️', label: '고장 신고' },
  REFUND_GUIDE: { icon: '💸', label: '환불 안내' },
  FRANCHISE: { icon: '🤝', label: '창업·가맹 문의' },
  // 출장·차량
  SERVICE_INTRO: { icon: '🚐', label: '서비스 소개' },
  LICENSE_PROOF: { icon: '📜', label: '자격·보험 증빙' },
  WORK_SITE: { icon: '📍', label: '작업 현장' },
  // 1인 기업·프리랜서
  PORTFOLIO: { icon: '💼', label: '포트폴리오', guide: '작업 사진과 PDF 파일을 직접 올리세요 (링크 아님)' },
  // 교회·단체 (260709 분리 — MEETING_TIME·JOIN_US는 단체·모임·협회 전용)
  SERVICE_TIME: { icon: '⛪', label: '예배 시간' },
  // 260720 아이콘/라벨 구분 — MAP(🗺️ 오시는 길·지도링크)과 교회 현판서 쌍둥이 큐브 되던 것.
  // 260804 유저 — DIRECTIONS는 '글+사진 안내'에서 **주소 공유**로 바뀌었다. 누르면 메인 공유 버튼과
  //   같은 창(앱=네이티브 시트 / 웹=OS 시트 / 인앱브라우저=카톡·문자·복사 폴백)이 주소를 담은 채 열린다.
  //   MAP=지도 앱으로 이동 / DIRECTIONS=주소를 남에게 보내기 — 역할이 갈린다.
  DIRECTIONS: { icon: '🧭', label: '찾아오시는 길' },
  CHURCH_INTRO: { icon: '⛪', label: '교회 소개' }, // 260720 교회 소개 — 저장 시 간판온 108 교회업체로 자동 연동(대표: 교회가 쓴 소개→간판온)
  SAINT_BIZ: { icon: '🏪', label: '성도 사업장' }, // 260722 시트5 #31 대표컨펌 — 디렉토리+등록 퍼널 타일
  PASTOR_INTRO: { icon: '🙏', label: '목사님 소개' },
  NEWCOMER: { icon: '🤗', label: '새가족 등록' }, // 260803 대표 — '안내'는 찍은 사람이 뭘 하는 곳인지 몰랐다(등록하는 곳임을 이름으로)
  SMALL_GROUP: { icon: '👥', label: '소모임·구역' }, // 260716 대표 오후회의(155743)
  OFFERING: { icon: '💰', label: '헌금 안내' },      // 260716 대표 오후회의(155743)
  TRANSFER: { icon: '🏦', label: '계좌이체', guide: '입금받을 계좌를 적으세요. 손님이 계좌번호를 눌러 복사할 수 있어요' }, // 260730 유저 지시 — 헌금 안내와 같은 포맷
  // 260803 대표 — 주보는 사진 촬영만 되던 걸 '직접 타이핑 + 외부 링크 + 사진·PDF' 셋 다로 넓혔다.
  //   ('링크 아님' 안내는 이제 거짓말이라 걷어냄. 260720에 링크형→사진형으로 뒤집으며 박힌 문구)
  BULLETIN: { icon: '📰', label: '주보 보기', guide: '이번 주 주보를 직접 적거나, 사진·PDF를 올리거나, 홈페이지 주보 주소를 걸 수 있어요' },
  SERMON_TUBE: { icon: '▶️', label: '설교 영상', guide: '유튜브 채널 또는 설교 재생목록 공유 링크 복사' },
  DAILY_VERSE: { icon: '📖', label: '오늘의 말씀' },   // 260729 하루 한 구절(같은 날=같은 말씀) + '다른 말씀 보기'
  CHURCH_EVENT: { icon: '📢', label: '교회 행사' },
  MEETING_TIME: { icon: '🗓️', label: '모임 일정' },
  JOIN_US: { icon: '🙌', label: '가입·참여 문의' },
  // 부동산 (260709 세분화)
  LISTINGS: { icon: '🏘️', label: '매물 보기' },
  // 260724 카테고리 재정비 — 신규 템플릿그룹 전용 타일 6종(ROOMS만 신규 kind, 나머지는 TABLE/RICHTEXT/EVENTS 재사용)
  ROOMS: { icon: '🛏️', label: '객실 안내' },
  CHECKIN: { icon: '🕓', label: '입실·퇴실 안내' },
  AMENITY: { icon: '🧺', label: '부대시설·비품' },
  SHOWTIME: { icon: '🎬', label: '공연·상영 일정' },
  ADMISSION: { icon: '🎟️', label: '입장료 안내' },
  PICKUP: { icon: '🚖', label: '픽업·대차 안내' }
};

// 260715 대표/회의(발화자3) — "보기만 해도 뭔지 아는" 브랜드/로고형만 아이콘 유지, 나머지 정보·기능 타일은 글씨만(간결).
//   이 셋 = '유명해서 아이콘이 의미를 전달하는' platform의 단일 진원. 렌더러(관리 골라담기·랜딩 큐브)가 qrIsBranded로 분기.
//   260716 대표 "정말 메이저틱한것만" — 진짜 로고 마크만 유지로 축소(관리모드 렌더러 qrIsBranded 실배선). generic 이모지(배달🛵·지도🗺️·네이버플레이스🧭·네이버예약📅·카카오주문💬)는 로고가 아니라 글씨화 대상.
export const QR_BRANDED_PLATFORMS = new Set([
  'GANPANON',                                  // 우리 브랜드
  'INSTAGRAM', 'YOUTUBE', 'FACEBOOK', 'BLOG',  // SNS 로고
  'KAKAO_CH',                                  // 카카오 채널(💛)
  'NAVER_ORDER'                                // 네이버 주문(N)
]);
export const qrIsBranded = platform => QR_BRANDED_PLATFORMS.has(platform);

// 260710 토핑 카탈로그 그룹 — 관리 '버튼 골라 담기'·온보딩 '다른 업종 버튼 더 보기' 공용(대표 지시 "본인이 선택하게끔").
//   GANPANON(항상 깔림·고정 정책)·NOTICE(기본정보 한줄공지가 진원)·HOURS(기본정보 영업시간이 진원 — 260720 감사 ③ split-brain 방지)·폐지 타일은 담기 대상 제외.
//   여기 빠진 신규 platform은 qrToppingCatalog()가 '기타'로 자동 수거(누락 방지) — BE 카탈로그(QrTemplate.CATALOG)와 짝.
export const QR_TOPPING_GROUPS = [
  { name: '자주 쓰는 기능', keys: ['PHONE', 'MAP', 'PARKING', 'WIFI', 'TOILET', 'VCARD', 'SAVE_BIZ', 'ONLINE_MEMORIAL', 'BIZTALK', 'RECRUIT', 'URGENT_NOTICE', 'FAQ'] }, // GALLERY는 메인 대표사진 슬롯으로 전환, SAVE_BIZ·RECRUIT는 추가형 소비자 타일, URGENT_NOTICE(260804 긴급 공지)·FAQ(260814 매장 Q&A)는 업종을 안 가려 여기
  { name: 'SNS·링크', keys: ['INSTAGRAM', 'NAVER_PLACE', 'GOOGLE_MAP', 'HOMEPAGE', 'KAKAO_CH', 'YOUTUBE', 'FACEBOOK', 'BLOG', 'SHOP', 'PORTFOLIO'] }, // 260818 구글 맵 = 네이버 플레이스 옆(같은 '외부 플레이스 링크')
  // 260721 회의: 행사 독립 그룹 — 행사=회원가입 연결 진입점. 키는 이동(복사 금지 — qrToppingCatalog dedupe 없음)
  { name: '행사·이벤트', keys: ['EVENT_INFO', 'GAME', 'FIRST_EVENT', 'TRIAL', 'CHURCH_EVENT'] },
  { name: '먹거리', keys: ['MENU', 'NAVER_ORDER', 'KAKAO_ORDER', 'BAEMIN', 'YOGIYO', 'COUPANG_EATS', 'DELIVERY', 'WAITING', 'GROUP_INQUIRY', 'ORIGIN_LABEL'] },
  { name: '미용·건강', keys: ['PRICE_MENU', 'BUSY_MESSAGE', 'NAVER_BOOKING', 'BEFORE_AFTER', 'STAFF_INTRO', 'CLINIC_HOURS', 'DEPARTMENTS', 'RESERVATION', 'NON_COVERED', 'FLOOR_PARKING'] },
  { name: '교육·클래스', keys: ['TIMETABLE', 'TUITION', 'CONSULT', 'SHUTTLE', 'RESULTS', 'CURRICULUM', 'LEVEL_TEST', 'ACADEMY_EVENT'] }, // 260825 학원 확장 3종
  { name: '사무·회사', keys: ['COMPANY_INTRO', 'COMPANY_NEWS', 'CONTACTS', 'CATALOG', 'QUOTE', 'TRANSFER', 'DOORBELL', 'CAR_REG', 'COURIER_NOTE', 'ATTENDANCE'] },
  { name: '매장·무인', keys: ['HOW_TO_USE', 'EMERGENCY', 'REPORT_ISSUE', 'REFUND_GUIDE', 'FRANCHISE'] },
  { name: '출장·현장', keys: ['SERVICE_INTRO', 'LICENSE_PROOF', 'WORK_SITE', 'PICKUP'] }, // 260724 PICKUP 편입(그룹 남발 방지)
  { name: '숙박', keys: ['ROOMS', 'CHECKIN', 'AMENITY'] },       // 260724 카테고리 재정비
  { name: '문화·관람', keys: ['SHOWTIME', 'ADMISSION'] },        // 260724 카테고리 재정비
  { name: '부동산', keys: ['LISTINGS'] },
  // 260805 정리(14) 공통#3 — DIRECTIONS는 '오시는 길'(MAP)로 통합돼 목록에서 뺐다(QR_TILE_REMOVED가 이중으로도 막는다)
  { name: '교회·단체', keys: ['CHURCH_INTRO', 'SERVICE_TIME', 'PASTOR_INTRO', 'NEWCOMER', 'SMALL_GROUP', 'OFFERING', 'BULLETIN', 'SERMON_TUBE', 'DAILY_VERSE', 'MEETING_TIME', 'JOIN_US'] }
];

export const qrToppingCatalog = () => {
  // GALLERY=메인 대표사진 진원, HOURS=기본정보 영업시간 진원
  // ORDER_HUB=FE 가상 타일(BE 행 없음) — 담기 누르면 BE가 "지원하지 않는 버튼이에요"로 거부(QrAssetService catalogTile==null). 260728 가나다 평탄화로 노출이 커져 제외.
  // SIGNUP(260923 회원가입)도 같은 FE 가상 타일 — 빼지 않으면 관리 '꺼진 기능'에 죽은 카드로 뜨고, 개통 때 고르면 validatePlatforms 가 개통을 막는다.
  const excluded = ['GANPANON', 'NOTICE', 'HOURS', 'GALLERY', 'ORDER_HUB', 'SIGNUP', ...QR_TILE_REMOVED, ...QR_TILE_COMING_SOON];
  const grouped = new Set(QR_TOPPING_GROUPS.flatMap(g => g.keys));
  const groups = QR_TOPPING_GROUPS.map(g => ({
    name: g.name,
    items: g.keys
      .filter(k => QR_PLATFORM_META[k] && !excluded.includes(k))
      .map(k => ({ key: k, ...QR_PLATFORM_META[k] }))
  }));
  const rest = Object.keys(QR_PLATFORM_META)
    .filter(k => !grouped.has(k) && !excluded.includes(k))
    .map(k => ({ key: k, ...QR_PLATFORM_META[k] }));
  if (rest.length) groups.push({ name: '기타', items: rest });
  return groups.filter(g => g.items.length);
};

// 260728 대표 회의 — 관리 '더보기' 시트는 대분류 없이 전체를 가나다순 한 줄로 편다.
//   대표: "카테고리별로 나누면 교집합이 너무 많아. (…) 나는 병원인데 내 기능 꼭 써야 될 게 어디 주차장이 있어."
//   qrToppingCatalog()를 그대로 flatten — 제외 규칙(GANPANON·NOTICE·HOURS·GALLERY·폐지·준비중)의 진원을 한 곳으로 유지.
//   QR_TOPPING_GROUPS는 온보딩(QrOnboard)·BE QrTemplate.CATALOG와 짝이라 그대로 둔다.
export const qrToppingFlat = () => qrToppingCatalog()
  .flatMap(g => g.items)
  .sort((a, b) => a.label.localeCompare(b.label, 'ko'));

// ── 260729 대표: "가나다순으로 세웠으면 가이드라인인 가·나·다는 있어야 될 것 같아" ──
//   긴 목록(토핑 80종·소분류 21종)이 정렬만 돼 있으면 사장님 눈엔 그냥 긴 목록이라 스캔이 안 된다.
//   한글 첫 글자에서 초성을 뽑아 구분 머리글을 세운다. 겹자음은 대표자음으로 접는다(까→ㄱ).
const CHOSUNG = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
const CHOSUNG_FOLD = { 'ㄲ': 'ㄱ', 'ㄸ': 'ㄷ', 'ㅃ': 'ㅂ', 'ㅆ': 'ㅅ', 'ㅉ': 'ㅈ' };
export const qrChosung = (label = '') => {
  const c = (label.trim() || ' ').charCodeAt(0);
  if (c >= 0xac00 && c <= 0xd7a3) {                       // 완성형 한글 음절
    const ch = CHOSUNG[Math.floor((c - 0xac00) / 588)];
    return CHOSUNG_FOLD[ch] || ch;
  }
  if (c >= 0x3131 && c <= 0x314e) return CHOSUNG_FOLD[label[0]] || label[0]; // 자음 단독(ㄱ~ㅎ)
  return '#';                                             // 영문·숫자·이모지 — 맨 뒤 묶음
};
/** [{ head:'ㄱ', items:[…] }, …] — 가나다 정렬 + 초성 구분. '#'(비한글)은 항상 맨 뒤. */
export const qrGroupByChosung = (list = [], labelOf = it => it.label) => {
  const sorted = [...list].sort((a, b) => labelOf(a).localeCompare(labelOf(b), 'ko'));
  const out = [];
  sorted.forEach(it => {
    const head = qrChosung(labelOf(it));
    const last = out[out.length - 1];
    if (last && last.head === head) last.items.push(it);
    else out.push({ head, items: [it] });
  });
  const etc = out.filter(g => g.head === '#');
  return [...out.filter(g => g.head !== '#'), ...etc];
};

// 260730 매물 보기 간편 모드 — 사장이 이미 매물을 올려둔 부동산 플랫폼으로 손님을 바로 보낸다.
//   유저 지시 "간단에는 그냥 직방이나 다방 바로 연결". 대표 3곳만 두고 그 외는 상세 모드의 매물별 링크로 커버.
//   ⚠️key는 contentJson.links의 저장키 = 변경 금지(바꾸면 기존 저장분이 유령이 됨).
export const QR_LISTING_PLATFORMS = [
  { key: 'zigbang', label: '직방', example: 'zigbang.com/…' },
  { key: 'dabang', label: '다방', example: 'dabangapp.com/…' },
  { key: 'naverLand', label: '네이버부동산', example: 'land.naver.com/…' }
];

// 261026 크리에이터(유튜버) 현판 — 비회원이 누르면 간판ON 가입을 거치는 칸(10/23 대표 회의 '공동구매·제휴 문의는 가입하게').
//   CreatorLanding 의 가입 안내와 QrLanding 의 가입 뒤 복귀(?view=)가 같이 본다 — 값은 CreatorLanding view 키.
export const QR_CREATOR_JOIN_VIEWS = ['events', 'inquiry'];
